export const LOG_IN = 'log_in';
export const OR = 'or';
export const EMAIL = 'email';
export const MAIN_PAGE = 'main.page';
export const LOGO = 'logo';
export const ERROR = 'error';
export const RESULT = 'result';
export const SUBMITTING = 'submitting';
export const NO_RESULTS = 'no_results';
export const LOADING = 'loading';
export const WE_GOT_AN_ERROR = 'we_got_an_error';
export const DAY_OF_WEEK_MONDAY_LONG = 'day_of_week.monday_long';
export const DAY_OF_WEEK_TUESDAY_LONG = 'day_of_week.tuesday_long';
export const DAY_OF_WEEK_WEDNESDAY_LONG = 'day_of_week.wednesday_long';
export const DAY_OF_WEEK_THURSDAY_LONG = 'day_of_week.thursday_long';
export const DAY_OF_WEEK_FRIDAY_LONG = 'day_of_week.friday_long';
export const DAY_OF_WEEK_SATURDAY_LONG = 'day_of_week.saturday_long';
export const DAY_OF_WEEK_SUNDAY_LONG = 'day_of_week.sunday_long';
export const DAY_OF_WEEK_MONDAY_SHORT = 'day_of_week.monday_short';
export const DAY_OF_WEEK_TUESDAY_SHORT = 'day_of_week.tuesday_short';
export const DAY_OF_WEEK_WEDNESDAY_SHORT = 'day_of_week.wednesday_short';
export const DAY_OF_WEEK_THURSDAY_SHORT = 'day_of_week.thursday_short';
export const DAY_OF_WEEK_FRIDAY_SHORT = 'day_of_week.friday_short';
export const DAY_OF_WEEK_SATURDAY_SHORT = 'day_of_week.saturday_short';
export const DAY_OF_WEEK_SUNDAY_SHORT = 'day_of_week.sunday_short';
export const SUGGESTED_CALENDAR_TOP = 'pdp.suggested_calendar.top';
export const SUGGESTED_CALENDAR_LINK = 'pdp.suggested_calendar.link';
export const SUGGESTED_CALENDAR_BOTTOM = 'pdp.suggested_calendar.bottom';
export const STORE_TIMINGS = 'pas.store_timings';
export const STORE_IS_NOT_FOUND_FOR_ZIP =
  'pdp.main.error.store_not_found_for_zip';
export const STORE_IS_NOT_FOUND_FOR_ARRANGEMENT_FOR_ZIP =
  'pdp.main.error.store_not_found_for_arrangement_for_zip';
export const STORE_IS_NOT_AVAILABLE_FOR_DATE =
  'pdp.main.error.store_not_available_for_date';
export const CHOOSE_RECIPIENT = 'pdp.choose_recipient';
export const PDP_TITLE = 'pdp.title';
export const RECIPIENT_INFORMATION_ERROR_CAR_MODEL =
  'recipient_information.error_car_model';
export const RECIPIENT_INFORMATION_ERROR_CAR_COLOR =
  'recipient_information.error_car_color';
export const RECIPIENT_INFORMATION_ERROR_VEHICLE_MODEL =
  'recipient_information.error_car_model';
export const RECIPIENT_INFORMATION_ERROR_VEHICLE_COLOR =
  'recipient_information.error_car_color';
export const RECIPIENT_INFORMATION_ERROR_PICKUP_TIME =
  'recipient_information.error_pickup_time';
export const PICKUP_FORM_ERROR_PHONE =
  'recipient_information.error_pickup_phone';
export const NUMBER_OF_SIZES_ONE = 'arrangement_list_item.number_of_sizes.one';
export const NUMBER_OF_SIZES_TWO = 'arrangement_list_item.number_of_sizes.two';
export const NUMBER_OF_SIZES_THREE =
  'arrangement_list_item.number_of_sizes.three';
export const NUMBER_OF_SIZES_FOUR =
  'arrangement_list_item.number_of_sizes.four';
export const NUMBER_OF_SIZES_FIVE =
  'arrangement_list_item.number_of_sizes.five';
export const NUMBER_OF_SIZES_SIX = 'arrangement_list_item.number_of_sizes.six';
export const NUMBER_OF_SIZES_SEVEN =
  'arrangement_list_item.number_of_sizes.seven';
export const NUMBER_OF_SIZES_EIGHT =
  'arrangement_list_item.number_of_sizes.eight';
export const NUMBER_OF_SIZES_NINE =
  'arrangement_list_item.number_of_sizes.nine';
export const NUMBER_OF_SIZES_TEN = 'arrangement_list_item.number_of_sizes.ten';
export const NUMBER_OF_SIZES_STARTING_AT =
  'arrangement_list_item.number_of_sizes.starting_at';
export const NUMBER_OF_SIZES_NUMERIC_QUANTITY =
  'arrangement_list_item.number_of_sizes.sizes_starting_at';
export const NUMBER_OF_SIZES_NUMERIC_OPTIONS =
  'arrangement_list_item.number_of_sizes.sizes_options';
export const NUMBER_OF_SIZES_NUMERIC_OPTION =
  'arrangement_list_item.number_of_sizes.sizes_option';
export const NUMBER_OF_SIZES_NO_SIZES =
  'arrangement_list_item.number_of_sizes.no_sizes';
export const IMAGE_NOT_AVAILABLE = 'plp.image.not_available';
export const BACK = 'common.back';
export const CLOSE = 'close';
export const SUBMIT = 'submit';
export const SELECT_ADDRESS_TYPE =
  'recipient_information.validation.select_address_type';
export const ENTER_BUSINESS_NAME =
  'recipient_information.validation.enter_business_name';
export const ENTER_SCHOOL_NAME =
  'recipient_information.validation.enter_school_name';
export const ENTER_HOSPITAL_NAME =
  'recipient_information.validation.enter_hospital_name';
export const PAS_NETWORK_ERR = 'pas.network_err';
export const HEADER_USER_PROFILE_MENU_SIGN_OUT = 'header.user_profile.sign_out';
export const HEADER_USER_PROFILE_MENU_SIGN_UP = 'header.user_profile.sign_up';
export const HEADER_USER_PROFILE_ACCOUNT = 'header.account';
export const HEADER_USER_PROFILE_MY_REWARDS = 'header.user_profile.my_rewards';
export const HEADER_USER_PROFILE_FAQ = 'header.user_profile.faq_and_benefits';
export const HEADER_USER_PROFILE_MY_INFORMATION =
  'header.user_profile.my_information';
export const HEADER_USER_PROFILE_ORDER_HISTORY =
  'header.user_profile.order_history';
export const HEADER_USER_PROFILE_GIFT_REMINDERS =
  'header.user_profile.gift_reminders';
export const HEADER_USER_PROFILE_ADDRESS_BOOK =
  'header.user_profile.address_book';
export const HEADER_HELP = 'header.help';
export const HEADER_FIND_STORE = 'header.find_store';
export const HEADER_EDIBLE_REWARDS = 'header.edible_rewards';
export const HEADER_SHOPPING_CART = 'header.shopping_cart';
export const HEADER_HELP_TRACK_YOUR_ORDER = 'header.help_track_your_orders';
export const HEADER_HELP_CONTACT_US = 'header.help_contact_us';
export const HEADER_HELP_ALLERGY_SAFETY_INFORMATION =
  'header.help_allergy_safety_information';
export const HEADER_HELP_PROMOTION_TERMS_CONDITIONS =
  'header.help_promotion_terms_conditions';
export const HEADER_HELP_CERTIFIED_HAPPINESS =
  'header.help_certified_happiness';
export const HEADER_HELP_EDIBLE_GUARANTEE = 'header.help_edible_guarantee';
export const HEADER_GET_HELP = 'header.get_help';
export const HEADER_HELP_FAQS = 'header.help_faqs';
export const HEADER_HELP_PRODUCTS_POLICY = 'header.help_products_policy';
export const HEADER_STORES_FRANCHISE_OPPORTUNITIES =
  'header.stores.franchise_opportunities';
export const HEADER_STORES_EDIBLE_TREATS = 'header.stores.edible_treats';
export const HEADER_ABOUT_WHO_WE_ARE = 'header.about.who_we_are';
export const HEADER_ABOUT_OUR_MISSION = 'header.about.our_mission';
export const HEADER_ABOUT_OUR_HISTORY = 'header.about.our_history';
export const HEADER_ABOUT_FOUNDER = 'header.about.founder';
export const HEADER_ABOUT_CONTACT_US = 'header.about.contact_us';
export const HEADER_OTHER_CAREERS = 'header.other.careers';
export const HEADER_OTHER_PRESS = 'header.other.press';
export const HEADER_OTHER_BLOG = 'header.other.blog';
export const HEADER_NAV_CUSTOMER_SERVICE = 'header.nav.customer_service';
export const HEADER_NAV_STORES = 'header.nav.stores';
export const HEADER_NAV_ABOUT = 'header.nav.about';
export const HEADER_NAV_ABOUT_EDIBLE = 'header.nav.about_edible';
export const HEADER_NAV_OTHER = 'header.nav.other';
export const HEADER_NAV_MENU = 'header.nav.menu';
export const HEADER_NAV_MORE_LINKS = 'header.nav.more_links';
export const HEADER_NAV_LANGUAGE = 'header.nav.language';
export const SLIDER_NEXT = 'slider.next';
export const SLIDER_PREVIOUS = 'slider.previous';
export const SUBSCRIPTION_FOOTER_TITLE = 'subscription.title';
export const SUBSCRIPTION_SHOP_NOW = 'subscription.shop_now';
export const SUBSCRIPTION_TERMS_AND_CONDITIONS_BEFORE =
  'subscription.terms_and_conditions.before';
export const SUBSCRIPTION_TERMS_AND_CONDITIONS_BETWEEN_AND =
  'subscription.terms_and_conditions.between_and';
export const SUBSCRIPTION_EMAIL_FORM_BUTTON_LABEL =
  'subscription.email_form.button_label';
export const SUBSCRIPTION_TERMS_AND_CONDITIONS_AFTER =
  'subscription.terms_and_conditions.after';
export const SUBSCRIPTION_EMAIL_FORM_LABEL = 'subscription.email_form.label';
export const SUBSCRIPTION_EMAIL_FORM_TERMS_AND_CONDITIONS =
  'subscription.email_form.terms_and_conditions';
export const NEW_SUBSCRIPTION_FIRST_POPUP_TITLE = 'subscription.popup_title';
export const NEW_SUBSCRIPTION_FIRST_POPUP_JOIN_EMAIL_TEXT =
  'subscription.Join_our_email';
export const NEW_SUBSCRIPTION_SIGNUP_FIRST_JOIN_EMAIL_SMS_TEXT =
  'subscription.Join_our_email_or_SMS';
export const NEW_SUBSCRIPTION_FIRST_POPUP_INSTANT_SAVINGS_TEXT =
  'subscription.instant_savings';
export const NEW_SUBSCRIPTION_FIRST_POPUP_INSTANT_TEXT = 'subscription.instant';
export const NEW_SUBSCRIPTION_FIRST_POPUP_SAVINGS_TEXT = 'subscription.savings';
export const NEW_SUBSCRIPTION_FIRST_POPUP_PICKUP_ORDER_TEXT =
  'subscription.on_your_next_pickup';
export const SUBSCRIPTION_FIRST_POPUP_TITLE =
  'subscription.Something_You_ll_Love';
export const SUBSCRIPTION_FIRST_POPUP_OFFER_VAL = 'subscription.15';
export const SUBSCRIPTION_FIRST_POPUP_OFFER_PER = 'subscription.percent';
export const SUBSCRIPTION_FIRST_POPUP_OFFER_TEXT = 'subscription.off';
export const SUBSCRIPTION_FIRST_POPUP_OFFER_STAR = 'subscription.star';
export const SUBSCRIPTION_FIRST_POPUP_DESCRIPTION =
  'subscription.your_next_pickup_order';
export const SUBSCRIPTION_NEW_SUCCESS_POPUP_TITLE = 'subscription.sweet';
export const SUBSCRIPTION_SUCCESS_POPUP_DESCRIPTION_FIRST =
  'subscription.thanks_for_signing_up';
export const SUBSCRIPTION_SUCCESS_POPUP_DESCRIPTION_LAST =
  'subscription.for_15_off';
export const SUBSCRIPTION_SUCCESS_POPUP_SOCIAL_LINKS_TITLE =
  'subscription.connect_with_us';
export const SUBSCRIPTION_SUCCESS_POPUP_GIFT_TEXT =
  'subscription.order_a_freshly-crafted_gift';
export const SUBSCRIPTION_IMAGE_TITLE = 'subscription.delicious_fruit_design';
export const ERROR_PHONE = 'subscription.invalid_phone_number';
export const ERROR_EMAIL = 'subscription.invalid_email';
export const REQUIRED_EMAIL = 'subscription.email_is_required';
export const ERROR_AGREE = 'subscription.you_must_agree';
export const SUBSCRIPTION_FOOTER_FORM_EMAIL_LABEL =
  'subscription.email.address';
export const SUBSCRIPTION_FOOTER_FORM_SUBMIT = 'subscription.form.submit';
export const SUBSCRIPTION_FOOTER_FORM_EMAIL_ERROR =
  'subscription.form.email.error';
export const SUBSCRIPTION_FOOTER_SIGNUP_FORM_EMAIL_ERROR =
  'subscription.signup.form.email.error';
export const SUBSCRIPTION_TERMS_OF_USE = 'subscription.form.terms.use';
export const SUBSCRIPTION_FORM_PHONE_LABEL = 'subscription.form.phone.label';
export const SUBSCRIPTION_FORM_PHONE_ERROR = 'subscription.form.phone.error';
export const SUBSCRIPTION_FORM_SIGNUP_PHONE_ERROR =
  'subscription.form.signup.phone.error';
export const SUBSCRIPTION_FORM_POLICY_LABEL = 'subscription.form.policy.label';
export const SUBSCRIPTION_FORM_POLICY_ARIA_LABEL =
  'subscription.form.policy.aria.label';
export const SUBSCRIPTION_FORM_POLICY_TOOLTIP =
  'subscription.form.policy.tooltip';
export const SUBSCRIPTION_FORM_POLICY_TOOLTIP_LABEL =
  'subscription.form.policy.tooltip.label';
export const SUBSCRIPTION_FORM_POLICY_ERROR = 'subscription.form.policy.error';
export const SUBSCRIPTION_SIGNUP_POLICY_ERROR =
  'subscription.signup.form.policy.error';
export const ERROR_SPL_CHARS_BUSINESS_NAME =
  'recipient_information.validation.spl_chars_business_name';
export const ERROR_SPL_CHARS_SCHOOL_NAME =
  'recipient_information.validation.spl_chars_school_name';
export const ERROR_SPL_CHARS_HOSPITAL_NAME =
  'recipient_information.validation.spl_chars_hospital_name';
export const RECIPIENT_INFORMATION_ERROR_CAR_MODEL_SPL_CHARS =
  'recipient_information.error_car_model_spl_chars';
export const RECIPIENT_INFORMATION_ERROR_CAR_COLOR_SPL_CHARS =
  'recipient_information.error_car_color_spl_chars';
export const SOCIAL_LINKS_TITLE = 'social.links.title';
export const PAYMENT_OPTIONS_TITLE = 'payment.options.title';
export const NEAREST_STORE_TITLE = 'nearest.store.title';
export const NEAREST_STORE_TODAY_LABEL = 'nearest.store.today.label';
export const NEAREST_STORE_DIRECTIONS_LABEL = 'nearest.store.directions.label';
export const TERMS_OF_USE_LABEL = 'terms.of.use.label';
export const PRIVACY_POLICY_LABEL = 'privacy.policy.label';
export const PRIVACY_POLICY1_LABEL = 'privacy.policy1.label';
export const REQUIRED_LABEL = 'privacy.required.label';
export const CALIFORNIA_PRIVACY_RIGHTS_LABEL = 'california.privacy.label';
export const CORPORATE_PROMOTION_LABEL = 'corporate.promotion.label';
export const COOKIE_SETTINGS_LABEL = 'cookie.settings.label';
export const CORPORATE_COPYRIGHT_LABEL = 'corporate.copyright.label';
export const DESKTOP_SEARCH_PLACEHOLDER = 'desktop.search.placeholder';
export const SEARCH_HELPER_TEXT = 'search.helper.text';
export const SEARCH_SUGGESTED_RESULTS = 'suggested.results.text';
export const SEARCH_NO_SUGGESTIONS = 'search.no.suggestions.text';
export const SEARCHING_TEXT = 'searching.text';
export const ALL_RESULTS = 'all.results';
export const CHOOSE_VARIANT = 'choose.variant';
export const SINGLE_VARIANT = 'single.variant';
export const BLOG_CAROUSEL_TITLE = 'blog_carousel.title';
export const CANT_BEGIN_WITH_O_OR_1 = 'phone.cant_begin_with_0_or_1';
export const ENTER_ONE_PHONE_NUMBER = 'phone.enter_one_phone_number';
export const ENTER_ONE_VALID_PHONE_NUMBER =
  'phone.enter_one_valid_phone_number';
export const HOME_PAGE_VIEW_ALL = 'home_page.view_all';
export const HOME_PAGE_CAROUSEL_FORWARD_CONTROL =
  'home_page.carousel_forward_control';
export const HOME_PAGE_CAROUSEL_BACKWARDS_CONTROL =
  'home_page.carousel_backward_control';
export const NEAREST_STORE_WEEKLY_HOURS = 'nearest_store.weekly_hours';
export const NEAREST_STORE_PHONE_CONTACT = 'nearest_store.phone_contact';
export const NEAREST_STORE_DIRECTIONS = 'nearest_store.directions';
export const HOME_PAGE_H1_HEADING = 'home_page.h1_heading';
export const FRANCHISE_BANNER_TITLE = 'home_page.franchise_banner.title';
export const FRANCHISE_BANNER_BODY = 'home_page.franchise_banner.body';
export const FRANCHISE_BANNER_BUTTON = 'home_page.franchise_banner.button';
export const POPULAR_CATEGORIES = 'home_page.popular_categories';
export const VIEW_DETAILS = 'product_listing.view_details';
export const HIDE_DETAILS = 'product_listing.hide_details';
export const EDIBLE_GUARANTEE_TITLE = 'edible_guarantee.title';
export const EDIBLE_GUARANTEE_DESCRIPTION = 'edible_guarantee.description';
export const EDIBLE_GUARANTEE_POLICY = 'edible_guarantee.policy';
export const EDIBLE_GUARANTEE_HASSLEFREE = 'edible_guarantee.hassle_free';
export const EDIBLE_GUARANTEE_SATISFACTION_HEADER =
  'edible_guarantee.satisfaction_header';
export const EDIBLE_GUARANTEE_SUPPORT_HEADER =
  'edible_guarantee.support_header';
export const EDIBLE_GUARANTEE_STREAMLINED_HEADER =
  'edible_guarantee.streamlined_header';
export const EDIBLE_GUARANTEE_SATISFACTION = 'edible_guarantee.satisfaction';
export const EDIBLE_GUARANTEE_SUPPORT = 'edible_guarantee.support';
export const EDIBLE_GUARANTEE_STREAMLINED = 'edible_guarantee.streamlined';
export const ALERT_OWN_BOX_ADDONS = 'alert.own_box_addons';
export const ALERT_PRODUCT_OPTION = 'alert.product_option';
export const ALERT_AVAILABILITY_ZIP = 'alert.availability_zip';
export const ALERT_AVAILABILITY_DATE = 'alert.availability_date';
export const ALERT_AVAILABILITY_DELIVERY_METHOD =
  'alert.availability_delivery_method';
export const ALERT_AVAILABILITY_STORE = 'alert.availability_store';
export const ALERT_SUGGESTED_DATE = 'alert.suggested_date';
export const ALERT_SUGGESTED_PRODUCT = 'alert.suggested_product';
export const ALERT_DESSERT_OWN_BOX_ADDONS = 'alert.dessert_own_box_addons';
export const ALERT_6_COOKIE_BOX_ADDONS = 'alert.6_cookie_box_addons';
export const ALERT_12_COOKIE_BOX_ADDONS = 'alert.12_cookie_box_addons';
export const ALERT_CUPCAKE_ADDONS = 'alert.cupcake_box_addons';
export const ALERT_WRAP_ADDONS = 'alert.wrap_addons';
export const PICKUP = 'pdp.pickup';
export const DELIVERY = 'pdp.delivery';
export const MENU_TITLE = 'pdp.menu_title';
export const GUIDE = 'pdp.guide';
export const NEW_RECIPIENT_SUBTITLE = 'pdp.new_recipient_subtitle';
export const SWITCH_RECIPIENT = 'pdp.switch_recipient';
export const DELIVERY_FROM = 'pdp.delivery_from';
export const DELIVERY_FOR = 'pdp.delivery_for';
export const PICKUP_FROM = 'pdp.pickup_from';
export const PICKUP_FOR = 'pdp.pickup_for';
export const SHIPMENT_SERVICED_ON = 'pdp.shipment_serviced_on';
export const NEW_RECIPIENT = 'pdp.new_recipient';
export const PICK_UP = 'pdp.pick_up';
export const DELIVERY_DESCRIPTION = 'pdp.delivery_description';
export const AVAILABLE_FOR_OTHER_DATES = 'pdp.available_for_other_dates';
export const CHOOSE_ANOTHER_DATE = 'pdp.choose_another_date';
export const AVAILABLE_FOR_OTHER_PRODUCTS = 'pdp.available_for_other_products';
export const CHANGE_DELIVERY_STORE = 'pdp.change_delivery_store';
export const CHANGE_STORE = 'pdp.change_store';
export const OTHER_PRODUCTS_AVAILABLE = 'pdp.other_products_available';
export const DELIVERY_NOT_AVAILABLE_FOR_DATE_SUGGEST_DATES =
  'pdp.delivery_not_available_for_date_suggest_dates';
export const DELIVERY_NOT_AVAILABLE_FOR_DATE_SUGGEST_PRODUCTS =
  'pdp.delivery_not_available_for_date_suggest_products';
export const PICKUP_NOT_AVAILABLE_FOR_DATE_SUGGEST_DATES =
  'pdp.pickup_not_available_for_date_suggest_dates';
export const PICKUP_NOT_AVAILABLE_FOR_DATE_SUGGEST_PRODUCTS =
  'pdp.pickup_not_available_for_date_suggest_products';
export const FREE = 'pdp.free';
export const PICKUP_IN_STORE = 'pdp.pickup_in_store';
export const PICKUP_DESCRIPTION = 'pdp.pickup_description';
export const NO_APPROPRIATE_DATE = 'pdp.no_appropriate_date';
export const EXPLORE_AVAILABLE_PRODUCTS = 'pdp.explore_available_products';
export const SEE_AVAILABLE_PRODUCTS = 'pdp.see_available_products';
export const FLEX_FREE = 'pdp.flex_free';
export const FLEX_NEXT_DAY_PRICE = 'pdp.flex_next_day_price';
export const FLEX_NEXT_DAY_PRICE_CA = 'pdp.flex_next_day_price_ca';
export const FLEX_DATES_AVAILABLE = 'pdp.flex_dates_available';
export const FLEX_DELIVERY_DATES = 'pdp.flex_delivery_dates';
export const FLEX_DELIVERY_DATES_SUBTITLE = 'pdp.flex_delivery_dates_subtitle';
export const FLEX_DATES_AVAILABLE_SUBTITLE =
  'pdp.flex_dates_available_subtitle';
export const DISCLAIMER_MESSAGE = 'pdp.disclaimer_message';
export const DISCLAIMER_MESSAGE_KMS = 'pdp.disclaimer_message_kms';
export const CURBSIDE = 'pdp.curbside';
export const DISTANCE = 'pdp.distance';
export const KOSHER = 'pdp.kosher';
export const MILES = 'pdp.miles';
export const KILOMETERS = 'pdp.kilometers';
export const KILOMETERS_TEXT = 'pdp.kilometers_text';
export const SMOOTHIE = 'pdp.smoothie';
export const TITLE_PICKUP = 'pdp.title.pickup';
export const TITLE_DELIVERY = 'pdp.title.delivery';
export const SHOW_MORE = 'pdp.show_more';
export const VIEW_MORE = 'pdp.view_more';
export const MONDAY_FULL = 'pdp.monday.full';
export const TUESDAY_FULL = 'pdp.tuesday.full';
export const WEDNESDAY_FULL = 'pdp.wednesday.full';
export const THURSDAY_FULL = 'pdp.thursday.full';
export const FRIDAY_FULL = 'pdp.friday.full';
export const SATURDAY_FULL = 'pdp.saturday.full';
export const SUNDAY_FULL = 'pdp.sunday.full';
export const MONDAY_SHORT = 'pdp.monday.short';
export const TUESDAY_SHORT = 'pdp.tuesday.short';
export const WEDNESDAY_SHORT = 'pdp.wednesday.short';
export const THURSDAY_SHORT = 'pdp.thursday.short';
export const FRIDAY_SHORT = 'pdp.friday.short';
export const SATURDAY_SHORT = 'pdp.saturday.short';
export const SUNDAY_SHORT = 'pdp.sunday.short';
export const ERROR_NO_STORES = 'pdp.error.no_stores';
export const ERROR_DELIVERY_CUTOFF_PASSED = 'pdp.error.delivery_cutoff_passed';
export const ERROR_PICKUP_CUTOFF_PASSED = 'pdp.error.pickup_cutoff_passed';
export const ERROR_PICKUP_DATE_IN_PAST = 'pdp.error.pickup_date_in_past';
export const ERROR_SAME_DAY_SHIPMENT = 'pdp.error.same_day_shipment';
export const ERROR_NEXT_DAY_SHIPMENT_CUTOFF_PASSED =
  'pdp.error.next_day_shipment_cutoff_passed';
export const ERROR_SIZE_IS_NOT_AVAILABLE = 'pdp.error.size_is_not_available';
export const ERROR_STORE_IS_CLOSED = 'pdp.error.store_is_closed';
export const ERROR_PICKUP_CUTOFF_DATE = 'pdp.error.pickup_cutoff_date';
export const ERROR_BEFORE_MINIMUM_PICKUP_TIME =
  'pdp.error.before_minimum_pickup_time';
export const ERROR_SERVICING_STORE_CLOSED = 'pdp.error.servicing_store_closed';
export const ERROR_SERVICING_STORE_CANNOT_FULFILL_ORDER =
  'pdp.error.servicing_store_cannot_fulfill_order';
export const ERROR_DELIVERY_IS_NOT_AVAILABLE_FOR_STORE_ON_DATE =
  'pdp.error.delivery_is_not_available_for_store_on_date';
export const ERROR_PICKUP_IS_NOT_AVAILABLE_FOR_STORE_ON_DATE =
  'pdp.error.pickup_is_not_available_for_store_on_date';
export const SHOW_MORE_REVIEW = 'pdp.show_more_review';
export const PRODUCT_NO_REVIEW = 'pdp.product_no_review';
export const PRODUCT_REVIEW = 'pdp.product_review';
export const PRODUCT_REVIEWS = 'pdp.product_reviews';
export const PRODUCT_DESCRIPTION = 'pdp.product_description';

export const PRODUCT_DETAILS = 'pdp.product_details';

export const NO_BRAND_DESCRIPTION = 'pdp.no_brand_description';
export const PRODUCT_INGREDIENTS = 'pdp.product_ingredients';
export const QUESTIONS = 'pdp.questions';
export const COUPONS_APPLICABLE_TITLE = 'pdp.coupons_applicable_title';
export const FLAVORS_BREAKDOWN_WARNING = 'pdp.accordion.flavors.warning';
export const FLAVORS_BREAKDOWN_VIEW_MORE = 'pdp.accordion.flavors.viewMore';
export const FLAVORS_BREAKDOWN_VIEW_LESS = 'pdp.accordion.flavors.viewLess';
export const ALLERGY_WARNING_TITLE = 'pdp.allergy_warning_title';
export const DISCLAIMER_TITLE = 'pdp.disclaimer_title';
export const INGREDIENT_ALLERY_LINK = 'pdp.ingredient_link';
export const FAQ_LINK = 'pdp.faq_title';
export const SHOW_MORE_DELIVERY_STORES = 'pdp.show_more_delivery_stores';
export const WHEN = 'pdp.date_selection_when';
export const TODAY = 'pdp.date_selection_today';
export const DATE_SELECTION = 'pdp.date_selection';
export const DATE_CALENDAR_PICKER = 'pdp.date_calendar_picker';
export const TOMORROW = 'pdp.date_selection_tomorrow';
export const DATE_PICKER = 'pdp.date_selection_date_picker';
export const UPSELLS_DECREASE_QUANTITY = 'pdp.decrease_quantity';
export const UPSELLS_INCREASE_QUANTITY = 'pdp.increase_quantity';
export const UPSELLS_REMOVE = 'pdp.remove';
export const UPSELLS_ADD = 'pdp.add';
export const UPSELLS_CONTINUE = 'pdp.continue';
export const UPSELLS_SAVE_SELECTION = 'pdp.save_selections';
export const UPSELLS_TITLE = 'pdp.upgrade_your_gift';
export const UPSELLS_OPTIONS_SINGLE = 'pdp.single';
export const UPSELLS_OPTIONS_OPTION = 'pdp.option';
export const UPSELL_OPTIONS_STARTING_AT = 'pdp.options_starting_at';
export const UPSELL_OPTIONS_SHOW_ALL = 'pdp.show_all';
export const UPSELL_OPTIONS_EXPANDED_SINGLE = 'pdp.single_option';
export const UPSELL_OPTIONS_EXPANDED_SELECT_ONE = 'pdp.select_only_one_option';
export const UPSELL_OPTIONS_EXPANDED_SELECT_MULTIPLE = 'pdp.select_options';
export const UPSELL_OPTIONS_EXPANDED_SHOW_LESS = 'pdp.show_less';
export const UPSELL_OPTIONS_WARNING = 'pdp.upsell_warning';
export const UPSELL_OPTIONS_WARNING_DESIGN_VARY = 'pdp.design_may_vary';
export const UPSELL_OPTIONS_NOTICE = 'pdp.upsell_notice';
export const UPSELL_SHOW_MORE = 'pdp.show_more';
export const UPSELL_SHOWING = 'pdp.showing';
export const UPSELL_SHOW = 'pdp.show_more';
export const UPSELL_OPTIONS_PRODUCT_BADGE_LABEL = 'pdp.your_gift';
export const SAVE = 'pdp.save';
export const ADD = 'pdp.add';
export const CANCEL = 'pdp.cancel';
export const LETTERS_OPTION_TITLE = 'pdp.letters_option_title';
export const LETTERS_OPTION_MODAL_TITLE = 'pdp.letters_option_modal_title';
export const LETTERS_OPTION_EXAMPLE = 'pdp.letters_option_example';
export const LETTERS_OPTION_WARN = 'pdp.letters_option_warn';
export const LETTERS_INPUT_LABEL = 'pdp.letters_input_label';
export const NUMBERS_OPTION_TITLE = 'pdp.numbers_option_title';
export const NUMBERS_OPTION_MODAL_TITLE = 'pdp.numbers_option_modal_title';
export const NUMBERS_OPTION_EXAMPLE = 'pdp.numbers_option_example';
export const NUMBERS_OPTION_WARN = 'pdp.numbers_option_warn';
export const NUMBERS_INPUT_LABEL = 'pdp.numbers_input_label';
export const YEAR_OPTION_TITLE = 'pdp.year_option_title';
export const YEAR_OPTION_MODAL_TITLE = 'pdp.year_option_modal_title';
export const YEAR_OPTION_EXAMPLE = 'pdp.year_option_example';
export const YEAR_OPTION_WARN = 'pdp.year_option_warn';
export const YEAR_INPUT_LABEL = 'pdp.year_input_label';
export const EMPTY_VALUE_VALIDATION_ERROR_MESSAGE =
  'pdp.empty_value_validation_error_message';
export const CENSORED_WORD_VALIDATION_ERROR_MESSAGE =
  'pdp.censored_word_validation_error_message';
export const SWITCH_TO_THIS_OPTION = 'pdp.switch_to_this_option';
export const MAXIMUM_3_CHARACTERS = 'pdp.maximum_3_characters';
export const MAXIMUM_5_CHARACTERS = 'pdp.maximum_5_characters';
export const ONLY_NUMBERS_ALLOWED = 'pdp.only_numbers_allowed';
export const MUST_BE_4_CHARACTERS_LONG = 'pdp.must_be_4_characters_long';
export const ONLY_UPPERCASE_LETTERS_ALLOWED =
  'pdp.only_uppercase_letters_allowed';
export const PDP_RECIPIENT_NAME = 'recipient_form.recipient_name';
export const PDP_REQUIRED_FIELD = 'recipient_form.required_field';
export const PDP_FIRST_NAME_PLACEHOLDER =
  'recipient_form.first_name_placeholder';
export const PDP_FIRST_NAME_TEXT = 'recipient_form.first_name_text';
export const PDP_FIRST_NAME_TEXT_PICKUP =
  'recipient_form.first_name_text_pickup';
export const PDP_LAST_NAME_PLACEHOLDER = 'recipient_form.last_name_placeholder';
export const PDP_ADDRESS_TYPE_RESIDENCE_TITLE =
  'recipient_form.address_type_residence_title';
export const PDP_ADDRESS_TYPE_RESIDENCE_SUBTITLE =
  'recipient_form.address_type_residence_sub_title';
export const PDP_ADDRESS_TYPE_BUSINESS_TITLE =
  'recipient_form.address_type_business_title';
export const PDP_ADDRESS_TYPE_BUSINESS_SUBTITLE =
  'recipient_form.address_type_business_sub_title';
export const PDP_ADDRESS_TYPE_ERROR = 'recipient_form.address_type_error';
export const PDP_ADDRESS_TITLE = 'recipient_form.address_title';
export const PDP_ADDRESS_SUBTITLE = 'recipient_form.address_sub_title';
export const PDP_ADDRESS_TYPE_LABEL = 'recipient_form.address_type_label';
export const PDP_BUSINESS_NAME_LABEL = 'recipient_form.business_name_label';
export const PDP_CITY_LABEL = 'recipient_form.city_label';
export const PDP_PO_BOX_NOTE = 'recipient_form.po_box_note';
export const PDP_STREET_ADDRESS = 'recipient_form.street_address';
export const PDP_APT_FLOOR_SUITE_BUTTON =
  'recipient_form.apt_floor_suite_button';
export const PDP_APT_FLOOR_SUITE_LABEL = 'recipient_form.apt_floor_suite_label';
export const PDP_BUSINESS_WARNING = 'recipient_form.business_warning';
export const PDP_CHOOSE_OPTION = 'recipient_form.choose_option';
export const PDP_PICKUP_TIME = 'recipient_form.pickup_time';
export const PDP_ENTER_FIRST_NAME = 'recipient_form.enter_first_name';
export const PDP_ENTER_LAST_NAME = 'recipient_form.enter_last_name';
export const PDP_ERROR_ALERT_ADD_TO_CART_HEADING =
  'recipient_form.error_modal.add_to_cart.heading';
export const PDP_ERROR_ALERT_ADD_TO_CART_BODY =
  'recipient_form.error_modal.add_to_cart.body';
export const PDP_ERROR_PICKUP_IN_PAST =
  'recipient_form.error_modal.pickup_in_past';
export const PDP_ERROR_CHOOSE_SAME_DAY_PICKUP_TIME_AFTER =
  'recipient_form.error_modal.choose_same_day_pickup_time_after';
export const PDP_ERROR_CHOOSE_PICKUP_TIME_AFTER =
  'recipient_form.error_modal.choose_pickup_time_after';
export const PDP_ERROR_NEXT_DAY_SHIPMENT_CUTOFF =
  'recipient_form.error_modal.next_day_shipment_cutoff';
export const PDP_ERROR_NO_SERVICE_OPTION =
  'recipient_form.error_modal.no_service_option';
export const PDP_ERROR_SERVICE_OPTION_STORE =
  'recipient_form.error_modal.service_option_store';
export const PDP_ERROR_DELIVERY_NOT_AVAILABLE_ON_DATE_FOR_STORE =
  'recipient_form.error_modal.delivery_not_available_on_date_for_store';
export const PDP_ERROR_PICKUP_NOT_AVAILABLE_ON_DATE_FOR_STORE =
  'recipient_form.error_modal.pickup_not_available_on_date_for_store';
export const PDP_ERROR_ORDER_DATE_IN_PAST =
  'recipient_form.error_modal.order_date_in_past';
export const PDP_ERROR_STORE_CANNOT_FULFILL_ON_DATE =
  'recipient_form.error_modal.store_cannot_fulfill_on_date';
export const PDP_ERROR_STORE_IS_CLOSED_ON_DATE =
  'recipient_form.error_modal.store_closed_on_date';
export const PDP_ERROR_UNCOMPLETED_REQUIRED_FIELDS =
  'recipient_form.error_modal.uncompleted_required_fields';
export const PDP_ERROR_FIRST_NAME_SPL_CHARS =
  'recipient_form.error_first_name_spl_chars';
export const PDP_ERROR_LAST_NAME_SPL_CHARS =
  'recipient_form.error_last_name_spl_chars';
export const PDP_ERROR_STREET_ADDRESS_SPL_CHARS =
  'recipient_form.error_street_address_spl_chars';
export const PDP_ERROR_REQUIRED = 'recipient_form.error_required';
export const PDP_ERROR_NAME_SPL_CHARS = 'recipient_form.error_name_spl_chars';
export const PDP_ERROR_OCCASION_ID = 'recipient_form.error_occasion_id';
export const PICKUP_DATE_TIME_ALERT_ON = 'pickup_form.date_time.alert.on';
export const PICKUP_DATE_TIME_ALERT_DATE = 'pickup_form.date_time.alert.date';
export const PICKUP_FROM_FOR_STORE = 'pickup_form.from_for_store';
export const PICKUP_DATE_TIME_HEADER = 'pickup_form.date_time.header';
export const PICKUP_DATE_TIME_LABEL = 'pickup_form.date_time.label';
export const PICKUP_FORM_IDENTIFICATION = 'pickup_form.identification';
export const PICKUP_PHONE_LABEL = 'pickup_form.phone.label';
export const PICKUP_PHONE = 'pickup_form.phone';
export const PICKUP_FORM_CURBSIDE_SWITCH_LABEL =
  'pickup_form.curbside.switch.label';
export const PICKUP_CURBSIDE_MODEL_LABEL = 'pickup_form.curbside.model.label';
export const PICKUP_CURBSIDE_COLOR_LABEL = 'pickup_form.curbside.color.label';
export const PICKUP_INSTRUCTION_BUTTON = 'pickup_form.instruction.button';
export const PICKUP_INSTRUCTIONS_HEADER = 'pickup_form.instruction.header';
export const PICKUP_INSTRUCTIONS_LABEL = 'pickup_form.instruction.input.label';
export const PICKUP_DETAILS = 'pickup_form.pickup.details';
export const PICKUP_CONTACT_DETAILS = 'pickup_form.pickup.contact.details';
export const DELIVERY_INSTRUCTIONS = 'instructions.delivery_instructions';
export const READ_OUR_DELIVERY_POLICIES =
  'instructions.read_our_delivery_policies';
export const DELIVERY_INSTRUCTIONS_LABEL =
  'instructions.delivery_instructions_label';
export const DELIVERY_INSTRUCTIONS_HELPER_TEXT =
  'instructions.delivery_helper_text';
export const DELIVERY_INSTRUCTIONS_PLACEHOLDER =
  'instructions.delivery_instructions_placeholder';
export const PICKUP_INSTRUCTIONS = 'instructions.pickup_instructions';
export const PICKUP_DATETIME = 'instructions.pickup_datetime';
export const PICKUP_INSTRUCTIONS_PLACEHOLDER =
  'instructions.pickup_instructions_placeholder';
export const PICKUP_INSTRUCTIONS_HELPER_TEXT =
  'instructions.pickup_instructions_helper_text';
export const COMPLIMENTARY_GIFT_MESSAGE =
  'greetings_cards.complimentary_gift_message';
export const COMPLIMENTARY_MESSAGE_TITLE =
  'greetings_cards.complimentary_message.title';
export const REMOVE_GIFT_MESSAGE = 'greetings_cards.remove_card_message';
export const GIFT_MESSAGE_FREE_EXPLAIN =
  'greetings_cards.gift_message_free_explain';
export const GIFT_MESSAGE_EDIT_LABEL =
  'greetings_cards.gift_message_edit_label';
export const GIFT_MESSAGE_EDIT_PLACEHOLDER =
  'greetings_cards.gift_message_edit_placeholder';
export const HEARTFELT_MESSAGE = 'greetings_cards.heartfelt_message';
export const TOP_PICK = 'greetings_cards.top_pick';
export const OPTIONAL = 'greetings_cards.optional';
export const PRINTIBLE_SUBTITLE = 'greetings_cards.printible_subtitle';
export const PRINTIBLE_OLD_PRICE_TEXT =
  'greetings_cards.printible_old_price_text';
export const PRINTIBLE_PRICE_SUBTEXT =
  'greetings_cards.printible_price_subtext';
export const PREMIUM_CARD = 'greetings_cards.premium_card';
export const SELECT_NEW_CARD = 'greetings_cards.select_new_card';

export const REMOVE_CARD = 'greetings_cards.remove_card';
export const GIFT_MESSAGE_FREE_HINT = 'greetings_cards.gift_message_free_hint';
export const ENTER_CARD_MESSAGE = 'greetings_cards.enter_card_message';
export const PRINTIBLE_CARD_PREVIEW = 'greetings_cards.card_preview';
export const PRINTIBLE_APP = 'greetings_cards.printible_app';
export const PRINTIBLE_IFRAME_ERROR = 'greetings_cards.printible_iframe_error';
export const PRINTIBLE_PRICE_TEXT = 'greetings_cards.printible_price_text';
export const COMPLIMENTARY_CARD = 'greetings_cards.complimentary_card';
export const PRINTIBLE_CARDS = 'greetings_cards.printible_cards';
export const GIFT_CARD_MODAL_TITLE = 'gift_card_modal.title';
export const GIFT_CARD_MODAL_SUB_TITLE = 'gift_card_modal.sub_title';
export const GIFT_CARD_MODAL_GIFT_MESSAGE = 'gift_card_modal.gift_message';
export const GIFT_CARD_MODAL_KEEPSAKE_CHERISH =
  'gift_card_modal.keepsake_cherish';
export const GIFT_CARD_MODAL_YEAR_COME = 'gift_card_modal.year_come';
export const WRITE_FOR_ME_NAME = 'write_for_me.name';
export const ANANYMOUSLY_SWITCH_LABEL = 'write_for_me.ananymously.switch.label';
export const WRITE_FOR_ME_NAME_NOTE = 'write_for_me.name.note';
export const WRITE_FOR_ME_CREATE_BUTTON = 'write_for_me.create_button';
export const WRITE_FOR_ME_START_NEW_BUTTON = 'write_for_me.start_new_button';
export const GIFT_MESSAGE_TABS_LABEL = 'write_for_me.tabs_label';
export const GIFT_MESSAGE_FIRST_TAB_LABEL = 'write_for_me.first_tab_label';
export const GIFT_MESSAGE_SECOND_TAB_LABEL = 'write_for_me.second_tab_label';
export const OWN_DESSERT_BOARD_BAKED = 'pdp.alert.dessert_board_baked';
export const OWN_DESSERT_BOARD_DIPPED_BERRIES =
  'pdp.alert.dessert_board_dipped_berries';
export const OWN_DESSERT_BOARD_DIPPED_FRUIT =
  'pdp.alert.dessert_board_dipped_fruit';
export const TITLE = 'pdp.alert.title';
export const AREA = 'area.area';
export const POSTAL_CODE = 'area.postal_code';
export const CHANGE_POSTAL_CODE = 'area.change_postal_code';
export const STATE = 'area.state';
export const PROVINCE = 'area.province';
export const CITY = 'area.city';
export const CHANGE_AREA = 'area.change_area';
export const CHANGE_AREA_INFO = 'area.change_area_info';
export const CHANGE_POSTAL_CODE_INFO = 'area.change_postal_code_info';
export const CART_POSTAL_CODE_INFO = 'area.cart_postal_code_info';
export const CHANGE_ZIP_TITLE = 'area.change_zip_title';
export const CHANGE_ZIP_DESCRIPTION = 'area.change_zip_description';
export const CHANGE_BACK_BUTTON = 'area.change_back_button';
export const CHANGE_ZIP_BUTTON = 'area.change_zip_button';
export const CHANGE_POSTAL_BUTTON = 'area.change_postal_button';
export const CHANGE_POSTAL_TITLE = 'area.change_postal_title';
export const CHANGE_POSTAL_DESCRIPTION = 'area.change_postal_description';
export const PRODUCT_FAQ = 'pdp.accordion.faq';
export const PRODUCT_FLAVOR_BREAKDOWN = 'pdp.accordion.flavor_breakdown';
export const BRAND_VALUE = 'pdp.brand_value';
export const STORES_NEAR_YOU = 'store_finder_page.stores_near_you';
export const STORE_NEAR_YOU = 'store_finder_page.store_near_you';
export const CONCERNED_ABOUT_PRIVACY =
  'store_finder_page.concerned_about_privacy';
export const LOAD_MORE_STORES_BUTTON_TEXT =
  'store_finder_page.load_more_button_text';
export const PRIVACY_POLICY = 'store_finder_page.privacy_policy';
export const TERMS_OF_USE = 'store_finder_page.terms_of_use';
export const LOCATION_SERVICES_OFF = 'store_finder_page.location_services_off';
export const TURN_ON_LOCATION_SERVICES =
  'store_finder_page.turn_on_location_services';
export const STORE_SHOWING_AMOUNT_DISPLAY_TEXT =
  'store_finder_page.stores_showing_amount_display_text';
export const STORE_SHOWING_LOAD_MORE_TEXT =
  'store_finder_page.stores_showing_load_more_text';
export const SEARCH_BY_OCCASION = 'store_finder_page.search_by_occasion';
export const CUSTOM_GREETING_CARDS = 'store_finder_page.custom_greeting_cards';
export const APPLY = 'store_finder_page.apply';
export const CLEAR_ALL_FILTERS = 'store_finder_page.clear_all_filters';
export const CLEAR_ALL_FILTERS_ARIA =
  'store_finder_page.clear_all_applied_filters';
export const REMOVE_FILTER_ARIA = 'store_finder_page.remove_filter_aria';
export const ERROR_MESSAGE_OPEN_YOUR_OWN_STORE =
  'store_finder_page.error_message.open_your_own_store';
export const ERROR_MESSAGE_OH_NO = 'store_finder_page.error_message.oh_no';
export const ERROR_MESSAGE_DIFFERENT_SEARCH_AND_FILTER =
  'store_finder_page.error_message.different_search_and_filter';
export const ERROR_MESSAGE_DIFFERENT_SEARCH =
  'store_finder_page.error_message.try_different_search_value';
export const ERROR_MESSAGE_WE_SHIP_TEXT =
  'store_finder_page.error_message.we_ship_text';
export const ERROR_MESSAGE_SEARCH_AND_FILTER_CRITERIA =
  'store_finder_page.error_message.no_criteria_match';
export const ERROR_MESSAGE_NEW_STORES_TEXT =
  'store_finder_page.error_message.new_stores_text';
export const ERROR_MESSAGE_OPEN_STORE_TEXT =
  'store_finder_page.error_message.open_stores_text';
export const DISTANCE_FILTER_OPTION = 'store_finder_page.distance_filter';
export const DISTANCE_TEXT = 'store_finder_page.distance_text';
export const SERVICES_OFFERED_TEXT = 'store_finder_page.service_offered_text';
export const FILTERS_TEXT = 'store_finder_page.filters_text';
export const MOBILE_FILTER_TEXT = 'store_finder_page.mobile_filters_text';
export const STORE_FINDER_HOME = 'store_finder_page.home';
export const FIND_A_STORE = 'store_finder_page.find_a_store';
export const STORE_FINDER_TITLE = 'store_finder_page.title';
export const STORE_FINDER_DESCRIPTION = 'store_finder_page.description';
export const STORE_FINDER_PLACEHOLDER = 'store_finder_page.placeholder';
export const STORE_FINDER_PLACEHOLDER_CA = 'store_finder_page.placeholder_ca';
export const STORE_FINDER_LOCATION = 'store_finder_page.location_text';
export const STORE_FINDER_CHOOSE_FROM_LIST =
  'store_finder_page.choose_from_list_text';
export const STORE_FINDER_VALIDATION_ERROR =
  'store_finder_page.validation_error';
export const STORE_FINDER_VALIDATION_ERROR_CA =
  'store_finder_page.validation_error_ca';
export const INPUT_ADORNMENT = 'store_finder_page.input_adornment';
export const INPUT_ADORNMENT_CA = 'store_finder_page.input_adornment_ca';
export const STORE_FINDER_BUTTON = 'store_finder_page.button';
export const STORE_FINDER_BUTTON_LOADING_TEXT =
  'store_finder_page.button_loading_text';
export const STORE_FINDER_FRANCHISE_DESCRIPTION =
  'store_finder_page.franchise_description';
export const LEARN_MORE_STORES = 'store_finder_page.learn_more';
export const LOAD_MORE_STORE_LIST_ARIA_TEXT =
  'store_finder_page.load_more_store_list_aria_text';
export const LOAD_MORE_STORES_ARIA_TEXT =
  'store_finder_page.load_more_stores_aria_text';
export const OPEN_FRANCHISE_LEARN_MORE_BUTTON =
  'store_finder_page.open_your_own_franchise_learn_more_button';
export const OPEN_FRANCHISE_BANNER =
  'store_finder_page.open_your_own_franchise_banner';
export const INVALID_SEARCH_TEXT = 'store_finder_page.invalid_search_text';
export const COMING_SOON_STORE_TEXT =
  'store_finder_page.coming_soon_store_text';
export const CALL_EDIBLE_STORE = 'store_finder_page.call_edible_store';
export const EMAIL_EDIBLE_STORE = 'store_finder_page.email_edible_store';
export const CONTACT_US = 'store_finder_page.email_contact_us';
export const GET_DIRECTIONS = 'store_finder_page.get_edible_store_directions';
export const STORE_FINDER_PAGE_META_TAG_TITLE =
  'store_finder_page.seo_page_title';
export const STORE_FINDER_PAGE_META_TAG_DESCRIPTION =
  'store_finder_page.seo_page_description';
export const MARKETPLACE_ZIP_CODE_LABEL =
  'recipient_form.marketplace_zip_code_label';
export const MARKETPLACE_STATE_LABEL = 'recipient_form.marketplace_state_label';
export const MARKETPLACE_RECIPIENT_STATE_OTHER =
  'recipient_form.marketplace_state_other';
export const MARKETPLACE_STATE_SELECT =
  'recipient_form.marketplace_state_select';
export const MARKETPLACE_UNAVAILABLE_ALERT_TITLE =
  'recipient_form.marketplace_unavailable_title';
export const MARKETPLACE_UNAVAILABLE_ALERT_BODY =
  'marketplace_unavailable_body';
export const MARKETPLACE_EMAIL_ERROR_MESSAGE = 'marketplace_email_error';
export const MARKETPLACE_UNAVAILABLE_ALERT_LINK =
  'marketplace_unavailable_link';
export const SERVICED_AREAS_TITLE = 'store_details.serviced_areas_title';
export const STORE_DETAILS_BREADCRUMB = 'store_details.breadcrumb';
export const STORE_ADDRESS1 = 'store_details.store_address1';
export const STORE_ADDRESS2 = 'store_details.store_address2';
export const ABOUT_STORE_TITLE = 'store_details.about_store_title';
export const ABOUT_STORE_ONE = 'store_details.about_store_one';
export const ABOUT_STORE_TWO = 'store_details.about_store_two';
export const ABOUT_STORE_THREE = 'store_details.about_store_three';
export const FRANCHISE_BANNER_SUB_TITLE = 'franchise_banner.sub_title';
export const FRANCHISE_BANNER_TEXT_CONTAINER =
  'franchise_banner.text_container';
export const FRANCHISE_BANNER_ARIA_TITLE_LABEL = 'franchise_banner.title_label';
export const FRANCHISE_BANNER_ARIA_LABEL = 'franchise_banner.aria_label';
export const FRANCHISE_BANNER_BUTTON_LABEL =
  'franchise_banner.button_aria_label';
export const FRANCHISE_BANNER_SUB_TITLE_LABEL =
  'franchise_banner.sub_title_aria_label';
export const FRANCHISE_BANNER_ARIA_BODY_LABEL =
  'franchise_banner.body_aria_label';
export const FRANCHISE_BANNER_ALT_TEXT = 'franchise_banner.alt_text';
export const STORE_BANNER_ALT_TEXT = 'store_banner.alt_text';
export const STORE_BANNER_TITLE = 'store_banner.title';
export const STORE_BANNER_BODY = 'store_banner.body';
export const STORE_BANNER_BUTTON = 'store_banner.button';
export const SOCIAL_MEDIA_TITLE = 'social_media.title';
export const SOCIAL_MEDIA_BODY = 'social_media.body';
export const SOCIAL_INSTAGRAM_ARIA_LABEL = 'social.instagram.aria_label';
export const SOCIAL_FACEBOOK_ARIA_LABEL = 'social.facebook.aria_label';
export const SOCIAL_TWITTER_ARIA_LABEL = 'social.twitter.aria_label';
export const SOCIAL_PINTEREST_ARIA_LABEL = 'social.pinterest.aria_label';
export const SOCIAL_YOUTUBE_ARIA_LABEL = 'social.youtube.aria_label';
export const CATEGORIES_TITLE = 'categories.title';
export const DISTANCE_AWAY = 'store_widget.icon.distance_away';
export const DISTANCE_METRIC = 'store_widget.icon.distance_metric';
export const POPULAR_GIFT = 'store_details.popular_gift';
export const POPULAR_GIFTS = 'store_details.popular_gifts';
export const TODAYS_STORE_HOURS = 'store_details.todays_store_hours';
export const HOURS = 'store_details.hours';
export const BLOG_CAROUSEL = 'store_details.blog_carousel';
export const STORE_DETAILS_META_SCHEMA_DESCRIPTION =
  'store_details.meta.schema_description';
export const STORE_DETAILS_ADDRESS1 = 'store_details.address1';
export const STORE_DETAILS_ADDRESS2 = 'store_details.address1_and_address2';
export const STORE_DETAILS_META_TITLE = 'store_details.meta.title';
export const STORE_DETAILS_META_DESCRIPTION = 'store_details.meta.description';
export const DIRECTIONS = 'store_details.directions';

export const STORE_COMING_SOON_ADDRESS =
  'store_coming_soon_details.store_address';
export const COMING_SOON_TEXT =
  'store_coming_soon_details.store_coming_soon_text';

export const FRANCHISE_BANNER_STORE_COMING_SOON_BODY = 'franchise_banner.body';
export const FRANCHISE_BANNER_STORE_COMING_SOON_BUTTON =
  'franchise_banner.button';
export const FRANCHISE_BANNER_STORE_COMING_SOON_ALT_TEXT =
  'franchise_banner.alt_text';
export const STORE_BANNER_COMING_SOON_ALT_TEXT = 'store_banner.alt_text';
export const STORE_BANNER_COMING_SOON_TITLE = 'store_coming_soon_banner.title';
export const STORE_BANNER_COMING_SOON_BODY = 'store_coming_soon_banner.body';
export const STORE_BANNER_COMING_SOON_BUTTON = 'store_banner.button';
export const STORE_COMING_SOON_ABOUT_STORE_TITLE =
  'store_coming_soon_details.about_store_title';
export const STORE_COMING_SOON_ABOUT_STORE_ONE =
  'store_coming_soon_details.about_store_one';
export const STORE_COMING_SOON_ABOUT_STORE_TWO =
  'store_coming_soon_details.about_store_two';
export const STORE_COMING_SOON_ABOUT_STORE_THREE =
  'store_coming_soon_details.about_store_three';
export const STORE_COMING_SOON_ABOUT_STORE_FOUR =
  'store_coming_soon_details.about_store_four';
export const STORE_COMING_SOON_SOCIAL_MEDIA_TITLE = 'social_media.title';
export const STORE_COMING_SOON_SOCIAL_MEDIA_BODY = 'social_media.body';
export const STORE_COMING_SOON_SOCIAL_INSTAGRAM_ARIA_LABEL =
  'social.instagram.aria_label';
export const STORE_COMING_SOON_SOCIAL_FACEBOOK_ARIA_LABEL =
  'social.facebook.aria_label';
export const STORE_COMING_SOON_SOCIAL_TWITTER_ARIA_LABEL =
  'social.twitter.aria_label';
export const STORE_COMING_SOON_SOCIAL_PINTEREST_ARIA_LABEL =
  'social.pinterest.aria_label';
export const STORE_COMING_SOON_SOCIAL_YOUTUBE_ARIA_LABEL =
  'social.youtube.aria_label';
export const STORE_COMING_SOON_CATEGORIES_TITLE = 'categories.title';
export const STORE_COMING_SOON_DISTANCE_AWAY =
  'store_widget.icon.distance_away';
export const STORE_COMING_SOON_DETAILS_META_SCHEMA_DESCRIPTION =
  'store_coming_soon_details.meta.schema_description';
export const STORE_COMING_SOON_DETAILS_NO_ADDRESS =
  'store_coming_soon_details.no_address';
export const STORE_COMING_SOON_DETAILS_ADDRESS1 =
  'store_coming_soon_details.title_address1';
export const STORE_COMING_SOON_DETAILS_ADDRESS2 =
  'store_coming_soon_details.title_address2';
export const STORE_COMING_SOON_DETAILS_META_TITLE =
  'store_coming_soon_details.meta.title';
export const STORE_COMING_SOON_DETAILS_META_DESCRIPTION =
  'store_coming_soon_details.meta.description';
export const SUBSCRIPTION_TITLE = 'store_coming_soon_subscription.title';
export const SUBSCRIPTION_SUBTITLE = 'store_coming_soon_subscription.subtitle';
export const REDIRECT_SECTION_TITLE =
  'store_coming_soon_subscription.redirect_title';
export const REDIRECT_SECTION_SUBTITLE = 'store_coming_soon.redirect_subtitle';
export const FIND_STORE_BUTTON = 'store_coming_soon.redirect_find_store';
export const MARKETPLACE_DIGITAL_CARD_TITLE = 'marketplace_digital_card_title';
export const MARKETPLACE_DIGITAL_CARD_SUBTITLE =
  'marketplace_digital_card_subtitle';
export const MARKETPLACE_DIGITAL_CARD_CHECKBOX_LABEL =
  'marketplace_digital_card_checkbox_label';
export const MARKETPLACE_DIGITAL_CARD_CHECKBOX_LABEL_DESCRIPTION =
  'marketplace_digital_card_checkbox_label_description';
export const MARKETPLACE_DIGITAL_CARD_TOOLTIP =
  'marketplace_digital_card_tooltip';
export const MARKETPLACE_DIGITAL_CARD_FROM_LABEL =
  'marketplace_digital_card_from_label';
export const MARKETPLACE_DIGITAL_CARD_FROM_HELPER =
  'marketplace_digital_card_from_helper';
export const MARKETPLACE_DIGITAL_CARD_MESSAGE_LABEL =
  'marketplace_digital_card_message_label';
export const MARKETPLACE_DIGITAL_CARD_MESSAGE_PLACEHOLDER =
  'marketplace_digital_card_message_placeholder';
export const MARKETPLACE_DIGITAL_CARD_IMAGE_PLACEHOLDER =
  'marketplace_digital_card_image_placeholder';
export const MARKETPLACE_DIGITAL_CARD_SELECTION_BUTTON =
  'marketplace_digital_card_selection_button';
export const MARKETPLACE_DIGITAL_CARD_MESSAGE_ERROR =
  'marketplace_digital_card_message_error';
export const MARKETPLACE_DIGITAL_CARD_EDIT_BUTTON =
  'marketplace_digital_card_edit_button';
export const MARKETPLACE_DIGITAL_CARD_DELETE_BUTTON =
  'marketplace_digital_card_delete_button';
export const MARKETPLACE_DIGITAL_CARD_MODAL_TITLE =
  'marketplace_digital_card_modal_title';
export const MARKETPLACE_DIGITAL_CARD_MODAL_BODY =
  'marketplace_digital_card_modal_body';
export const MARKETPLACE_DIGITAL_CARD_ERROR_BANNER =
  'marketplace_digital_card_error_banner';
export const SUBSCRIPTION_FOOTER_DIALOG_TITLE =
  'subscription.footer_dialog.title';
export const SUBSCRIPTION_FOOTER_DIALOG_SUBTITLE =
  'subscription.footer_dialog.subtitle';
export const SUBSCRIPTION_FOOTER_DIALOG_INFORM_EMAIL =
  'subscription.footer_dialog.inform_email';
export const SUBSCRIPTION_FOOTER_DIALOG_INFORM_TEXT =
  'subscription.footer_dialog.inform_text';
export const SUBSCRIPTION_FOOTER_DIALOG_SOCIAL_LINKS_TITLE =
  'subscription.footer_dialog.social_links_title';
export const SUBSCRIPTION_EMAIL_DIALOG_FORM_STEP_BACKGROUND_ALT =
  'subscription.email_dialog.form_step.background_alt';
export const SUBSCRIPTION_EMAIL_DIALOG_SUBMIT_SUCCESS_STEP_BACKGROUND_ALT =
  'subscription.email_dialog.submit_success_step.background_alt';
export const SUBSCRIPTION_FACEBOOK = 'subscription.facebook';
export const SUBSCRIPTION_TWITTER = 'subscription.twitter';
export const SUBSCRIPTION_INSTAGRAM = 'subscription.instagram';
export const SUBSCRIPTION_LINKEDIN = 'subscription.linkedin';
export const SUBSCRIPTION_YOUTUBE = 'subscription.youtube';
export const SUBSCRIPTION_EMAIL_FORM_ERROR = 'subscription.email_form.error';
export const SUBSCRIPTION_EMAIL_FORM_PLACEHOLDER =
  'subscription.email_form.placeholder';
export const CYO_BUNDLE_TITLE = 'cyo_bundle.title';
export const CYO_BUNDLE_DESCRIPTION = 'cyo_bundle.description';
export const CYO_BUNDLE_STEP_ONE = 'cyo_bundle.step_one';
export const CYO_BUNDLE_STEP_TWO = 'cyo_bundle.step_two';
export const CYO_BUNDLE_STEP_THREE = 'cyo_bundle.step_three';
export const CYO_BUNDLE_START_CREATING = 'cyo_bundle.start_creating';
export const CYO_BUNDLE_MINI_CART_TITLE = 'cyo_bundle.mini_cart_title';
export const CYO_BUNDLE_MINI_CART_ADD_SAVE = 'cyo_bundle.mini_cart_add_save';
export const CYO_BUNDLE_MINI_CART_SUBTOTAL = 'cyo_bundle.mini_cart_subtotal';
export const CYO_BUNDLE_MINI_CART_TAX_FEE = 'cyo_bundle.mini_cart_tax_fee';
export const CYO_BUNDLE_PAS_TITLE = 'cyo_bundle.pas_title';
export const CYO_BUNDLE_PAS_SUB_TITLE = 'cyo_bundle.pas_sub_title';
export const LIMITED_LINES_HELPER_TEXT =
  'limited_text_field.limited_lines_helper_text';
export const FIELD_REQUIRED_HELPER_TEXT =
  'limited_text_field.field_required_helper_text';
export const LINES_LIMIT_EXCEEDED = 'limited_text_field.lines_limit_exceeded';
export const TYPING_LAST_LINE = 'limited_text_field.typing_last_line';
export const SPL_CHARS_ERROR = 'limited_text_field.spl_chars_error';
export const EMOJIS_ENTERED = 'limited_text_field.emojis_error';
export const REDUCE_MESSAGE_LENGTH_HELPER_TEXT =
  'limited_text_field.reduce_message_length_text';
export const REACHING_LAST_LINE = 'limited_text_field.reaching_last_line';
export const ORDER_CONFIRMATION_PAGE_THANK_YOU_MSG =
  'order_confirmation_page.thank_you_msg';
export const ORDER_CONFIRMATION_PAGE_ORDER_DETAILS_TITLE =
  'order_confirmation_page.order_details_title';
export const ORDER_CONFIRMATION_PAGE_CONFIRM_MAIL =
  'order_confirmation_page.confirm_mail';
export const ORDER_CONFIRMATION_PAGE_CONFIRM_MSG =
  'order_confirmation_page.confirm_msg';
export const ORDER_CONFIRMATION_PAGE_CONFIRM_HELP_MSG_PREFIX =
  'order_confirmation_page.confirm_help_msg';
export const ORDER_CONFIRMATION_PAGE_CONFIRM_HELP_MSG_SUFFIX =
  'order_confirmation_page.confirm_help_msg_suffix';
export const ORDER_CONFIRMATION_PAGE_PRINT_CONFIRMATION =
  'order_confirmation_page.print_confirmation';
export const ORDER_CONFIRMATION_PAGE_PRINT_ORDER_DETAILS =
  'order_confirmation_page.print_order_details';
export const ORDER_CONFIRMATION_PAGE_RESEND_CONFIRMATION =
  'order_confirmation_page.resend_confirmation';
export const ORDER_CONFIRMATION_PAGE_RECIPIENT_IMG =
  'order_confirmation_page.recipient_img';
export const ORDER_CONFIRMATION_PAGE_ORDER_TXT =
  'order_confirmation_page.order_txt';
export const ORDER_CONFIRMATION_PAGE_CREDIT_CARD_IMAGE =
  'order_confirmation_page.credit_card_image';
export const ORDER_CONFIRMATION_PAGE_CREATE_ACCOUNT =
  'order_confirmation_page.create_account';
export const ORDER_CONFIRMATION_PAGE_VIEW_REWARDS =
  'order_confirmation_page.view_rewards';
export const ORDER_CONFIRMATION_PAGE_TRACK_ORDER =
  'order_confirmation_page.track_order';
export const ORDER_CONFIRMATION_PAGE_TRACK_ORDER_IMG =
  'order_confirmation_page.track_order_img';
export const ORDER_CONFIRMATION_PAGE_HELP_GREY_ICON =
  'order_confirmation_page.help_grey_icon';
export const ORDER_CONFIRMATION_PAGE_DISCLAIMER_TEXT_LINE1 =
  'order_confirmation_page.disclaimer_text_line1';
export const ORDER_CONFIRMATION_PAGE_DISCLAIMER_TEXT_LINE2 =
  'order_confirmation_page.disclaimer_text_line2';
export const ORDER_CONFIRMATION_PAGE_BILLING_INFO_TITLE =
  'order_confirmation_page.billing_info_title';
export const ORDER_CONFIRMATION_PAGE_PICKUP_INFO_TITLE =
  'order_confirmation_page.pickup_info_title';
export const ORDER_CONFIRMATION_PAGE_PICKUP_IN_STORE =
  'order_confirmation_page.pickup_in_store';
export const ORDER_CONFIRMATION_PAGE_CURB_PICKUP =
  'order_confirmation_page.curb_pickup';
export const ORDER_CONFIRMATION_PAGE_PICKUP_INFO_METHOD =
  'order_confirmation_page.pickup_info_method';
export const ORDER_CONFIRMATION_PAGE_PICKUP_INFO_DATE =
  'order_confirmation_page.pickup_info_date';
export const ORDER_CONFIRMATION_PAGE_PICKUP_INFO_INSTRUCTION =
  'order_confirmation_page.pickup_info_instruction';
export const ORDER_CONFIRMATION_PAGE_PICKUP_INFO_NAME =
  'order_confirmation_page.pickup_info_name';
export const ORDER_CONFIRMATION_PAGE_PICKUP_INFO_FROM =
  'order_confirmation_page.pickup_info_from';
export const ORDER_CONFIRMATION_PAGE_DELIVERY_TITLE =
  'order_confirmation_page.delivery_title';
export const ORDER_CONFIRMATION_PAGE_SHIPMENT_TITLE =
  'order_confirmation_page.shipment_title';
export const ORDER_CONFIRMATION_PAGE_DELIVERY_POLICY =
  'order_confirmation_page.delivery_policy';
export const ORDER_CONFIRMATION_PAGE_SHIPMENT_POLICY =
  'order_confirmation_page.shipment_policy';
export const ORDER_CONFIRMATION_PAGE_DELIVERY_METHOD_NAME =
  'order_confirmation_page.delivery_method_name';
export const ORDER_CONFIRMATION_PAGE_DELIVERY_METHOD =
  'order_confirmation_page.delivery_method';
export const ORDER_CONFIRMATION_PAGE_ONE_HOUR_DELIVERY_METHOD =
  'order_confirmation_page.one_hour_delivery_method';
export const ORDER_CONFIRMATION_PAGE_SHIPMENT_METHOD =
  'order_confirmation_page.shipment_method';
export const ORDER_CONFIRMATION_PAGE_MORE_INFO =
  'order_confirmation_page.more_info';
export const ORDER_CONFIRMATION_PAGE_MORE_INFORMATION =
  'order_confirmation_page.more_information';
export const ORDER_CONFIRMATION_PAGE_SHIPMENT_INFO =
  'order_confirmation_page.shipment_info';
export const ORDER_CONFIRMATION_PAGE_CUSTOMER_CARE =
  'order_confirmation_page.customer_care';
export const ORDER_CONFIRMATION_PAGE_DELIVERY_INFO_ON =
  'order_confirmation_page.delivery_info_on';
export const ORDER_CONFIRMATION_PAGE_DELIVERY_INFO_INSTRUCTION =
  'order_confirmation_page.delivery_info_instruction';
export const ORDER_CONFIRMATION_PAGE_DELIVERY_INFO_TO =
  'order_confirmation_page.delivery_info_to';
export const ORDER_CONFIRMATION_PAGE_DELIVERY_INFO_FROM =
  'order_confirmation_page.delivery_info_from';
export const ORDER_CONFIRMATION_PAGE_AMAZON_PAY_IMAGE =
  'order_confirmation_page.amazon_pay_image';
export const ORDER_CONFIRMATION_PAGE_APPLE_PAY_IMAGE =
  'order_confirmation_page.apple_pay_image';
export const ORDER_CONFIRMATION_PAGE_GOOGLE_PAY_IMAGE =
  'order_confirmation_page.google_pay_image';
export const ORDER_CONFIRMATION_PAGE_LINK_IMAGE =
  'order_confirmation_page.link_image';
export const ORDER_CONFIRMATION_PAGE_PAID_BY =
  'order_confirmation_page.paid_by';
export const ORDER_CONFIRMATION_PAGE_PAID_BY_GPAY =
  'order_confirmation_page.paid_by_gpay';
export const ORDER_CONFIRMATION_PAGE_PAID_BY_LINK =
  'order_confirmation_page.paid_by_link';
export const ORDER_CONFIRMATION_PAGE_TRANSACTION_ID =
  'order_confirmation_page.transaction_id';
export const ORDER_CONFIRMATION_PAGE_NEED_MORE_SHOPPING =
  'order_confirmation_page.need_more_shopping';
export const ORDER_CONFIRMATION_PAGE_PAYMENT_ID =
  'order_confirmation_page.payment_id';
export const ORDER_CONFIRMATION_PAGE_VENMO_IMAGE =
  'order_confirmation_page.venmo_image';
export const ORDER_CONFIRMATION_PAGE_PAYPAL_IMAGE =
  'order_confirmation_page.paypal_image';
export const ORDER_CONFIRMATION_PAGE_PRODUCT_IMAGE =
  'order_confirmation_page.product_image';
export const ORDER_CONFIRMATION_PAGE_STRAWBERRY =
  'order_confirmation_page.strawberry';
export const ORDER_CONFIRMATION_PAGE_CHECK_ICON =
  'order_confirmation_page.check_icon';
export const ORDER_CONFIRMATION_PAGE_NO_INSTRUCTIONS =
  'order_confirmation_page.no_instructions';
export const ORDER_CONFIRMATION_PAGE_TERMS_TEXT =
  'order_confirmation_page.terms_text';
export const ORDER_CONFIRMATION_PAGE_LIST_TEXT1 =
  'order_confirmation_page.list_text1';
export const ORDER_CONFIRMATION_PAGE_LIST_TEXT2 =
  'order_confirmation_page.list_text2';
export const ORDER_CONFIRMATION_PAGE_ACC_TXT =
  'order_confirmation_page.acc_txt';
export const ORDER_CONFIRMATION_PAGE_THANKS_MSG =
  'order_confirmation_page.thanks_msg';
export const ORDER_CONFIRMATION_PAGE_ENJOY_MSG =
  'order_confirmation_page.enjoy_msg';
export const ORDER_CONFIRMATION_PAGE_TERMS_MSG =
  'order_confirmation_page.terms_msg';
export const ORDER_CONFIRMATION_PAGE_ORDERS_MSG =
  'order_confirmation_page.orders_msg';
export const ORDER_CONFIRMATION_PAGE_FREE_TXT =
  'order_confirmation_page.free_txt';
export const ORDER_CONFIRMATION_PAGE_FRUIT_TXT =
  'order_confirmation_page.fruit_txt';
export const ORDER_CONFIRMATION_PAGE_GIFT_MSG =
  'order_confirmation_page.gift_msg';
export const ORDER_CONFIRMATION_PAGE_GIFT_TXT =
  'order_confirmation_page.gift_txt';
export const ORDER_CONFIRMATION_PAGE_GREETING_TXT =
  'order_confirmation_page.greeting_txt';
export const ORDER_CONFIRMATION_PAGE_EMAIL_TXT =
  'order_confirmation_page.email_txt';
export const ORDER_CONFIRMATION_PAGE_ACC_LIST_TEXT1 =
  'order_confirmation_page.acc_list_text1';
export const ORDER_CONFIRMATION_PAGE_ACC_LIST_TEXT2 =
  'order_confirmation_page.acc_list_text2';
export const ORDER_CONFIRMATION_PAGE_ACC_LIST_TEXT3 =
  'order_confirmation_page.acc_list_text3';
export const ORDER_CONFIRMATION_PAGE_ACC_LIST_TEXT4 =
  'order_confirmation_page.acc_list_text4';
export const ORDER_CONFIRMATION_PAGE_ACC_LIST_TEXT5 =
  'order_confirmation_page.acc_list_text5';
export const ORDER_CONFIRMATION_PAGE_ACC_LIST_TEXT6 =
  'order_confirmation_page.acc_list_text6';
export const ORDER_CONFIRMATION_PAGE_ACC_LIST_TEXT7 =
  'order_confirmation_page.acc_list_text7';
export const ORDER_CONFIRMATION_PAGE_SPL_TXT =
  'order_confirmation_page.spl_txt';
export const ORDER_CONFIRMATION_PAGE_GREETING_MSG =
  'order_confirmation_page.greeting_msg';
export const ORDER_CONFIRMATION_PAGE_NEW_ORDER =
  'order_confirmation_page.new_order';
export const ORDER_CONFIRMATION_PAGE_KEEP_SHOPPING_TITLE =
  'order_confirmation_page.keep_shopping_title';
export const ORDER_CONFIRMATION_PAGE_UPGRADE_TEXT =
  'order_confirmation_page.upgrade_text';
export const ORDER_CONFIRMATION_PAGE_CYOA_TITLE1 =
  'order_confirmation_page.cyoa_title1';
export const ORDER_CONFIRMATION_PAGE_CYOA_TITLE2 =
  'order_confirmation_page.cyoa_title2';
export const ORDER_CONFIRMATION_PAGE_CYODB_TITLE =
  'order_confirmation_page.cyodb_title';
export const ORDER_CONFIRMATION_PAGE_CYODB_NAME =
  'order_confirmation_page.cyodb_name';
export const ORDER_CONFIRMATION_PAGE_CYO_6COOKIEBOX_TITLE =
  'order_confirmation_page.cyo_6cookiebox_title';
export const ORDER_CONFIRMATION_PAGE_CYO_12COOKIEBOX_TITLE =
  'order_confirmation_page.cyo_12cookiebox_title';
export const ORDER_CONFIRMATION_PAGE_CYO_6COOKIEBOX_NAME =
  'order_confirmation_page.cyo_6cookiebox_name';
export const ORDER_CONFIRMATION_PAGE_CYO_12COOKIEBOX_NAME =
  'order_confirmation_page.cyo_12cookiebox_name';
export const ORDER_CONFIRMATION_PAGE_CYO_6CUPCAKEBOX_TITLE =
  'order_confirmation_page.cyo_6cupcakebox_title';
export const ORDER_CONFIRMATION_PAGE_CYO_12CUPCAKEBOX_TITLE =
  'order_confirmation_page.cyo_12cupcakebox_title';
export const ORDER_CONFIRMATION_PAGE_CYO_6CUPCAKEBOX_NAME =
  'order_confirmation_page.cyo_6cupcakebox_name';
export const ORDER_CONFIRMATION_PAGE_CYO_12CUPCAKEBOX_NAME =
  'order_confirmation_page.cyo_12cupcakebox_name';
export const ORDER_CONFIRMATION_PAGE_CYO_DESSERT_NAME =
  'order_confirmation_page.cyo_dessert_name';
export const ORDER_CONFIRMATION_PAGE_CYO_DIPPEDFRUIT_NAME =
  'order_confirmation_page.cyo_dippedfruit_name';
export const ORDER_CONFIRMATION_PAGE_PACKAGE_TITLE1 =
  'order_confirmation_page.package_title1';
export const ORDER_CONFIRMATION_PAGE_PACKAGE_TITLE2 =
  'order_confirmation_page.package_title2';
export const ORDER_CONFIRMATION_PAGE_ORDER_HISTORY =
  'order_confirmation_page.order_history';
export const ORDER_CONFIRMATION_PAGE_SALE_TITLE =
  'order_confirmation_page.sale_title';
export const ORDER_CONFIRMATION_PAGE_ORDER_NUMBER =
  'order_confirmation_order_number';
export const ORDER_CONFIRMATION_PAGE_SALE_ITEM_COUNT =
  'order_confirmation_page.sale_item_count';
export const ORDER_CONFIRMATION_PAGE_SALE_QUANTITY =
  'order_confirmation_page.sale_quantity';
export const ORDER_CONFIRMATION_PAGE_SALE_ADDON_QUANTITY =
  'order_confirmation_page.sale_addon_quantity';
export const ORDER_CONFIRMATION_PAGE_SALE_PRICE =
  'order_confirmation_page.sale_price';
export const ORDER_CONFIRMATION_PAGE_SALE_SUMMARY =
  'order_confirmation_page.sale_summary';
export const ORDER_CONFIRMATION_PAGE_SALE_DELIVERY_FEE =
  'order_confirmation_page.sale_delivery_fee';
export const ORDER_CONFIRMATION_PAGE_SALE_SHIPMENT_CHARGE =
  'order_confirmation_page.sale_shipment_charge';
export const ORDER_CONFIRMATION_PAGE_SALE_SERVICE_FEE =
  'order_confirmation_page.sale_service_fee';
export const ORDER_CONFIRMATION_PAGE_SALE_SUBTOTAL =
  'order_confirmation_page.sale_subtotal';
export const ORDER_CONFIRMATION_PAGE_SALE_TOTAL =
  'order_confirmation_page.sale_total';
export const ORDER_CONFIRMATION_PAGE_COUPON_CODE =
  'order_confirmation_page.coupon_code';
export const ORDER_CONFIRMATION_PAGE_RECIPIENT =
  'order_confirmation_page.recipient';
export const ORDER_CONFIRMATION_CONTINUE_SHOPPING =
  'order_confirmation_page.continue.shopping';
export const ORDER_CONFIRMATION_RECIPIENT_TEXT =
  'order_confirmation_page.recipient.text';
export const ORDER_CONFIRMATION_RECIPIENTS_TEXT =
  'order_confirmation_page.recipients.text';
export const MARKETPLACE_CART_DIGITAL_CARD = 'marketplace.cart.digital_card';
export const MARKETPLACE_CART_DIGITAL_CARD_DESC =
  'marketplace.cart.digital_card_description';
export const MARKETPLACE_CART_DIGITAL_CARD_FREE =
  'marketplace.cart.digital_card_free';
export const MARKETPLACE_CART_DIGITAL_CARD_NOTIFICATIONS_ENABLED =
  'marketplace.cart.digital_card_notifications_enabled';
export const MARKETPLACE_CART_DIGITAL_CARD_EMAIL_DELIVERY =
  'marketplace.cart_digital_card_email_delivery';
export const MARKETPLACE_CART_DIGITAL_CARD_TEXT_DELIVERY =
  'marketplace.cart.digital_card_text_delivery';
export const MARKETPLACE_CART_DIGITAL_CARD_LINK_DELIVERY =
  'marketplace.cart.digital_card_link_delivery';
export const MARKETPLACE_CART_DIGITAL_CARD_ADD =
  'marketplace.cart.digital_card_no_add';
export const ORDER_CONFIRMATION_PAGE_PAYMENT_INFO =
  'order_confirmation_page.payment.info';
export const ORDER_CONFIRMATION_PAGE_PAYMENT_METHOD =
  'order_confirmation_page.payment.method';
export const ORDER_CONFIRMATION_PAGE_PAYMENT_CREDIT =
  'order_confirmation_page.payment.credit';
export const ORDER_CONFIRMATION_TIPPING_LEAVE_TIP =
  'order_confirmation_page.tipping.leave_tip';
export const ORDER_CONFIRMATION_TIPPING_DESCRIPTION =
  'order_confirmation_page.tipping_delivery.description';

export const ORDER_CONFIRMATION_TIPPING_INPUT_LABEL =
  'order_confirmation_page.tipping.input_label';
export const ORDER_CONFIRMATION_TIPPING_INPUT_LABEL_DEPLOYED =
  'order_confirmation_page.tipping.input_label_deployed';
export const ORDER_CONFIRMATION_TIPPING_TOOLTIP =
  'order_confirmation_page.tipping.tooltip';
export const ORDER_CONFIRMATION_TIPPING_EXCEEDS_ORDER_TOTAL =
  'order_confirmation_page.tipping.exceeds_order_total';

export const ORDER_CONFIRMATION_TIPPING_SUMMARY =
  'order_confirmation_page.tipping.summary';
export const ORDER_CONFIRMATION_TIPPING_SUMMARY_TOOLTIP =
  'order_confirmation_page.tipping.summary_tooltip';
export const ORDER_CONFIRMATION_TIPPING_DELIVERY_SUMMARY_TOOLTIP =
  'order_confirmation_page.tipping.summary_delivery_tooltip';
export const CART_ITEM_COUNT_SINGLE = 'heading.cart_item_count_single';
export const CART_ITEM_COUNT_MULTI = 'heading.cart_item_count_multi';
export const RECIPIENT_COUNT_SINGLE = 'heading.recipient_count_single';
export const RECIPIENT_COUNT_MULTI = 'heading.recipient_count_multi';
export const CONTINUE_SHOPPING = 'heading.continue_shopping';
export const RETURN_TO_CART = 'heading.return_to_cart';
export const CHECKOUT_NOW = 'heading.checkout_now';
export const RECIPIENT = 'heading.recipient';
export const RECIPIENT_VIEW_EDIT_BUTTON = 'heading.recipient_view_edit_button';
export const RECIPIENT_VIEW_EDIT_HIDE_BUTTON =
  'heading.recipient_view_edit_hide_button';
export const FREE_DELIVERY_REMAINING = 'heading.free_delivery_remaining';
export const FREE_DELIVERY_COMPLETED = 'heading.free_delivery_completed';
export const FREE_DELIVERY_COMPLETED_MOBILE =
  'heading.free_delivery_completed_mobile';
export const CART_TITLE = 'order_summary.title';
export const TOTAL = 'order_summary.total';
export const CART_TOTAL = 'order_summary.cart_total';
export const RECIPIENT_TOTAL = 'order_summary.recipient_total';
export const SUBTOTAL = 'order_summary.subtotal';
export const STATE_TAX = 'order_summary.state_tax';
export const LOCAL_TAX = 'order_summary.local_tax';
export const DELIVERY_POLICY = 'order_summary.delivery_help';
export const SHIPMENT_POLICY = 'order_summary.shipment_help';
export const EDIT_DELIVERY_INFO = 'order_summary.edit_delivery_info';
export const EDIT_SHIPPING_INFO = 'order_summary.edit_shipping_info';
export const EDIT_PICKUP_INFO = 'pickup.edit_pickup_info';
export const EDIT_DELIVERY_TITLE = 'order_summary.edit_delivery_title';
export const DELIVERY_FEE = 'order_summary.delivery_fee';
export const DISTANCE_FEE = 'order_summary.distance_fee';
export const SHIPMENT_CHARGE = 'order_summary.shipment_charge';
export const DISCOUNT_TOTAL = 'order_summary.discount_total';
export const PROMO_TEXT = 'order_summary.promo_text';
export const PROMO_CODE_TEXT = 'order_summary.promo_code_text';
export const ONE_HOUR_DELIVERY = 'order_summary.one_hour_delivery';
export const PROMO_EXPIRES = 'order_summary.promo_expires_text';
export const PROMO_MESSAGE = 'order_summary.promo_message_text';
export const MY_EDIBLE_REWARDS_TITLE = 'order_summary.my_edible_rewards_title';
export const PROMO_TOOLTIP = 'order_summary.promo_tooltip';
export const DELIVERY_TOOLTIP = 'order_summary.delivery_tooltip';
export const DISTANCE_FEE_TOOLTIP = 'order_summary.distance_fee_tooltip';
export const PROMO = 'order_summary.promo_code';
export const ADDON_IMAGE = 'order_summary.addon_image';
export const UPGRADE_IMAGE = 'order_summary.upgrade_image';
export const COMBINATION_IMAGE = 'order_summary.combination_image';
export const GREETING_TXT = 'order_summary.greeting_txt';
export const GIFT_TXT = 'order_summary.gift_txt';
export const HELP_GREY_ICON = 'order_summary.help_icon';
export const GREETING_MSG = 'order_summary.msg';
export const UPGRADE_TEXT = 'order_summary.upgrade_text';
export const WRAPPER_TEXT = 'order_summary.wrapper_text';
export const CYOA_TITLE1 = 'order_summary.cyoa_title1';
export const CYOA_TITLE2 = 'order_summary.cyoa_title2';
export const CYODB_TITLE = 'order_summary.cyodb_title';
export const CYO_6COOKIEBOX_TITLE = 'order_summary.cyo6cookiebox_title';
export const CYO_12COOKIEBOX_TITLE = 'order_summary.cyo12cookiebox_title';
export const CYO_6CUPCAKEBOX_TITLE = 'order_summary.cyo6cupcakebox_title';
export const CYO_12CUPCAKEBOX_TITLE = 'order_summary.cyo12cupcakebox_title';
export const CYO_DESSERT_NAME = 'order_summary.cyodessert_name';
export const CYO_DIPPEDFRUIT_NAME = 'order_summary.cyodippedfruit_name';
export const CYO_6COOKIEBOX_NAME = 'order_summary.cyo6cookiebox_name';
export const CYO_12COOKIEBOX_NAME = 'order_summary.cyo12cookiebox_name';
export const CYO_6CUPCAKEBOX_NAME = 'order_summary.cyo6cupcakebox_name';
export const CYO_12CUPCAKEBOX_NAME = 'order_summary.cyo12cupcakebox_name';
export const CYODB_NAME = 'order_summary.cyodb_name';
export const PACKAGE_TITLE1 = 'order_summary.package_title1';
export const PACKAGE_TITLE2 = 'order_summary.package_title2';
export const CURB_PICKUP = 'order_summary.curbside_pickup';
export const VEHICLE_MODEL = 'pickup.vehicle_model';
export const VEHICLE_COLOR = 'pickup.vehicle_color';
export const NO_INSTRUCTIONS = 'order_summary.no_instructions';
export const DELIVERY_TITLE = 'delivery_information.title';
export const DELIVERY_METHOD = 'delivery_information.method';
export const DELIVERY_DAY = 'delivery_information.day';
export const CART_DELIVERY_INSTRUCTIONS = 'delivery_information.instructions';
export const INDICATES_REQUIRED_FIELD = 'required_fields';
export const CART_DELIVERY_INSTRUCTIONS_PLACEHOLDER =
  'delivery_information.placeholder';
export const DELIVERING_TO = 'delivering_information.customer';
export const DELIVERY_TO = 'delivery_information.customer';
export const CART_DELIVERY_FROM = 'delivery_information.store';
export const HAND_DELIVERY = 'delivery_information.hand_delivery';
export const DISCLAIMER_1 = 'disclaimer.one';
export const DISCLAIMER_2 = 'disclaimer.two';
export const HELP_ICON = 'disclaimer.help_icon';
export const CART_COMPLIMENTARY_MESSAGE_TITLE = 'complimentary_message.title';
export const CART_COMPLIMENTARY_GIFT_MESSAGE =
  'complimentary_message.gift_title';
export const COMPLIMENTARY_NO_CARD_MESSAGE = 'complimentary_message.no_card';
export const ADD_GIFT_MESSAGE_WARING_TEXT1 =
  'complimentary_message.mesage_warning_text1';
export const ADD_GIFT_MESSAGE_WARING_TEXT2 =
  'complimentary_message.mesage_warning_text2';
export const ONE_HOUR_DELIVERY_WARNING_TITLE =
  'one_hour_delivery.warning_title';
export const ONE_HOUR_DELIVERY_WARNING_TEXT = 'one_hour_delivery.warning_text';
export const ADD_GIFT_MESSAGE = 'complimentary_message.giftmeassage';
export const CART_FREE = 'complimentary_message.free';
export const EDIT = 'complimentary_message.edit';
export const REMOVE = 'complimentary_message.remove';
export const MADE_IT_SPECIAL = 'product.made_it_special';
export const MAKE_IT_EXTRA_SPECIAL = 'product.make_it_extra_special';
export const SHOP_POPULAR_ADD_ONS = 'product.shop_popular_addons';
export const SAVE_EDIT_TEXT = 'complimentary_message.save_edit_text';
export const CANCEL_EDIT_TEXT = 'complimentary_message.cancel_edit_text';
export const GIFT_MESSAGE_LABEL = 'complimentary_message.gift_message_text';

export const START_SHOPPING = 'empty_cart.start_shopping';
export const EMPTY_TITLE = 'empty_cart.title';
export const EMPTY_SUBTITLE = 'empty_cart.subtitle';
export const EMPTY_DESCRIPTION = 'empty_cart.description';

export const PICKUP_TITLE = 'pickup_information.title';
export const PICKUP_METHOD = 'pickup_information.method';
export const PICKUP_DAY = 'pickup_information.day';
export const CART_PICKUP_INSTRUCTIONS = 'pickup_information.instructions';
export const CART_PICKUP_INSTRUCTIONS_LABEL = 'pickup_information.label';
export const CART_PICKUP_INSTRUCTIONS_PLACEHOLDER =
  'pickup_information.placeholder';
export const CART_PICKUP_TO = 'pickup_information.customer';
export const CART_PICKUP_FROM = 'pickup_information.store';
export const IN_STORE_PICKUP = 'pickup_information.in_store_pickup';
export const PICKUP_TIME_PASSED_TITLE = 'pickup_information.time_passed_title';
export const PICKUP_TIME_PASSED_DESCRIPTION =
  'pickup_information.time_passed_description';
export const PICKUP_DATE_PASSED_TITLE = 'pickup_information.date_passed_title';
export const PICKUP_DATE_PASSED_DESCRIPTION =
  'pickup_information.date_passed_description';
export const PICKUP_CHANGE_DATE = 'pickup_information.pickup_change_date';
export const PICKUP_CHANGE_TIME = 'pickup_information.pickup_change_time';
export const PICKUP_TO_CONTINUE = 'pickup_information.pickup_to_continue';
export const PICKUP_BELOW_CHANGE_TIME =
  'pickup_information.pickup_below_change_time';

export const SHIPMENT_TITLE = 'shipment_information.title';
export const SHIPMENT_METHOD = 'shipment_information.method';
export const SHIPMENT_DAY = 'shipment_information.day';
export const SHIPMENT_TO = 'shipment_information.customer';
export const SHIPPER = 'shipment_information.shipper';
export const SHIPMENT_METHOD_NAME = 'shipment_information.method';
export const SHIPMENT_METHOD_NAME_2 = 'shipment_information.method_2';
export const CART_SALE_TITLE = 'customer_service_page.sale_title';
export const CART_SALE_ITEM_COUNT = 'customer_service_page.sale_item_count';
export const CART_SALE_QTY = 'customer_service_page.sale_quantity';
export const CART_SALE_ADDON_QTY = 'customer_service_page.sale_addon_quantity';
export const CART_SALE_PRICE = 'customer_service_page.sale_price';
export const CART_SALE_SUMMARY = 'customer_service_page.sale_summary';
export const CART_SALE_DELIVERY_FEE = 'customer_service_page.sale_delivery_fee';
export const CART_SALE_SHIPMENT_CHARGE =
  'customer_service_page.sale_shipment_charge';
export const CART_SALE_SERVICE_FEE = 'customer_service_page.sale_service_fee';
export const CART_SALE_SUBTOTAL = 'customer_service_page.sale_subtotal';
export const CART_SALE_TOTAL = 'customer_service_page.sale_total';
export const REMOVE_DIALOG_TITLE = 'remove_product.title';
export const REMOVE_DIALOG_MESSAGE = 'remove_product.message';
export const REMOVE_DIALOG_BACK = 'Go Back';
export const REMOVE_DIALOG_CONFIRM = 'Confirm';
export const REMOVE_BUTTON_TITLE = 'product.remove';
export const EDIT_BUTTON_TITLE = 'product.edit';
export const EDIT_DIALOG_TITLE = 'edit_cart.edit_dialog';
export const EDIT_DIALOG_SUB_TITLE = 'edit_cart.edit_dialog_sub_title';
export const EDIT_DIALOG_SUB_TITLE_NO_UPGRADES =
  'edit_cart.edit_dialog_no_upgrades';
export const ORDER_CONTACTS_CELL_PHONE = 'Pickup Phone Number*';
export const FIRST_NAME_PLACEHOLDER = 'pickup_form.first_name_placeholder';
export const LAST_NAME_PLACEHOLDER = 'pickup_form.last_name_placeholder';
export const PICKUP_DATE_LABEL = 'pickup_information.pickup_date_label';
export const ONE_HOUR_DELIVERY_POPULAR = 'Popular';
export const ONE_HOUR_DELIVERY_CONTENT_TITLE = 'Last-minute shopping?';
export const ONE_HOUR_DELIVERY_CONTENT =
  "You're in luck! This order qualifies for One-Hour Delivery.";
export const PAYMENT_ONE_HOUR_DELIVERY_SELECTED = 'One-Hour Delivery Selected';
export const DELIVERY_ON = 'delivery_information.on_day';

export const CURB_SIDE_INFO = 'curb_side_pick_up.information';
export const IN_STORE_PICK_UP_INFO = 'in_store_pick_up.information';
export const SHIPPING_INFORMATION = 'shipping_information.title';
export const EDIT_CART_DIALOG_TITLE = 'edit_cart.dialog_title';
export const EDIT_CART_PRODUCT_CODE = 'edit_cart.product_code';
export const EDIT_CART_CHOOSE_OPTION = 'edit_cart.choose_an_option';
export const CART_ACCOUNT_TITLE = 'account.title_txt';
export const CART_ACCOUNT_BODY = 'account.body';
export const CART_ACCOUNT_EARN_TXT = 'account.earn_txt';
export const CART_ACCOUNT_ORDER_TXT = 'account.order_txt';
export const CART_ACCOUNT_ACCOUNT_TXT = 'account.account_txt';
export const CART_ACCOUNT_REWARDS_TXT = 'account.rewards_txt';
export const CART_ACCOUNT_LOGIN = 'account.login';
export const CART_ACCOUNT_CREATE_ACCOUNT = 'account.create_account';
export const CART_ACCOUNT_WELCOME_BACK = 'account.welcome_back';
export const CART_ACCOUNT_APPLY_REWARDS = 'account.apply_rewards';
export const CART_ACCOUNT_REWARD_TOOLTIP = 'account.reward_tooltip';
export const CART_ACCOUNT_ALLERGY_TEXT = 'account.allergy_text';
export const CART_ACCOUNT_FAQ_TEXT = 'account.faq_text';
export const CART_ACCOUNT_NO_REWARDS = 'account.no_rewards';
export const CART_ACCOUNT_NO_REWARDS_MESSAGE = 'account.no_rewards_message';
export const CART_ACCOUNT_CONTACTUS_TXT = 'contact.contacus_txt';
export const ORDER_CONFIRMATION_PAGE_PAYMENT_EXPIRY_DATE =
  'order_confirmation_page.payment.expiry.date';
export const MARKETPLACE_CART_SUGGESTION_ADD =
  'marketplace.cart.suggestion_add';
export const MARKETPLACE_CART_SHOP_POPULAR_PRODUCTS =
  'marketplace.cart.show_popular_products';
export const MARKETPLACE_CART_SHOP_NOW = 'marketplace.cart.shop_now';
export const MARKETPLACE_CART_ORDER_PART_TITLE =
  'marketplace.cart.order_part_title';
export const MARKETPLACE_CART_ORDER_RECIPIENT =
  'marketplace.cart.order_recipient';
export const MARKETPLACE_CART_SHIPPING = 'marketplace.cart.shipping';
export const MARKETPLACE_CART_SHIPPING_TIME = 'marketplace.cart.shipping_time';
export const MARKETPLACE_CART_FREE_SHIPMENT_REMAINING =
  'marketplace.cart.free_shipping_remaining';
export const MARKETPLACE_CART_FREE_SHIPMENT_COMPLETED =
  'marketplace.cart.free_shipping_completed';
export const MARKETPLACE_CART_SUGGESTION_STYLES_AVAILABLE =
  'marketplace.cart.suggestion_styles_available';
export const MARKETPLACE_CART_SUGGESTION_ONE_STYLE_AVAILABLE =
  'marketplace.cart.suggestion_one_style_available';
export const VDAY_SLIDER_CONTAINER_TITLE = 'vday_slider_widget.title';
export const VDAY_SLIDER_CONTAINER_SUBTITLE = 'vday_slider_widget.sub_title';
export const VDAY_SLIDER_TITLE = 'vday_slider.title';
export const VDAY_SLIDER_CONTAINER_TITLE1 = 'vday_slider_widget.title1';
export const VDAY_SLIDER_CONTAINER_TITLE2 = 'vday_slider_widget.title2';
export const VDAY_SLIDER_SHOP_BESTIE = 'vday_slider.shop_bestie';
export const VDAY_SLIDER_SHOP_SITUATIONSHIP = 'vday_slider.shop_situationship';
export const VDAY_SLIDER_SHOP_ESSENTIALS = 'vday_slider.shop_essentials';
export const VDAY_SLIDER_SHOP_FLIRT = 'vday_slider.shop_flirt';
export const VDAY_SLIDER_SHOP_LOVE = 'vday_slider.shop_love';
export const VDAY_SLIDER_URL_BESTIE = 'vday_slider.url_bestie';
export const VDAY_SLIDER_URL_SITUATIONSHIP = 'vday_slider.url_situationship';
export const VDAY_SLIDER_URL_ESSENTIALS = 'vday_slider.url_essentials';
export const VDAY_SLIDER_URL_FLIRT = 'vday_slider.url_flirt';
export const VDAY_SLIDER_URL_LOVE = 'vday_slider.url_love';
export const VDAY_SLIDER_BESTIE = 'vday_slider.bestie';
export const VDAY_SLIDER_SITUATIONSHIP = 'vday_slider.situationship';
export const VDAY_SLIDER_ESSENTIALS = 'vday_slider.essentials';
export const VDAY_SLIDER_FLIRT = 'vday_slider.flirt';
export const VDAY_SLIDER_LOVE = 'vday_slider.love';
export const ORDER_CONFIRMATION_NO_MESSAGE_TEXT =
  'order_confirmation_page.no.message.text';
export const CYO_BUNDLE_ITEM = 'cyo_bundle.mini_cart_item';
export const CYO_BUNDLE_ITEMS = 'cyo_bundle.mini_cart_items';
export const CYO_BUNDLE_ADD_PRODUCT = 'cyo_bundle.mini_cart_add_product';
export const CYO_BUNDLE_LIST_TITLE = 'cyo_bundle.list_title';
export const CYO_VIEW_PRODUCT_DETAILS = 'cyo_bundle.view_product_details';
export const CYO_BUNDLE_COUPON_BAR_TITLE = 'cyo_bundle.coupon_bar_title';
export const CYO_BUNDLE_COUPON_PROGRESS_TEXT =
  'cyo_bundle.coupon_progress_text';
export const CYO_BUNDLE_MAX_COUPON_REACHED = 'cyo_bundle.coupon_max_reached';
export const CYO_BUNDLE_FREE_DELIVERY = 'cyo_bundle.free_delivery';
export const HIDE_PASSWORD = 'hide_password';
export const SHOW_PASSWORD = 'show_password';
export const PREVIOUS_RECIPIENT = 'previous_recipient';
export const NEXT_RECIPIENT = 'next_recipient';
export const MP_ORDER_CONFIRMATION_ORDER_NUMBER =
  'marketplace.confirmation.order_number';
export const MARKETPLACE_TRACKING_NUMBER_TOOLTIP =
  'marketplace.tracking_number_tooltip';
export const MP_ORDER_CONFIRMATION_TRACK_ORDER =
  'marketplace.confirmation.track_order';
export const MP_ORDER_CONFIRMATION_SHIPPING_TITLE =
  'marketplace.confirmation.shipping_title';
export const MP_ORDER_CONFIRMATION_SHIPPING_INFO =
  'marketplace.confirmation.shipping_info';
export const MP_ORDER_CONFIRMATION_SHIPPING_DATE =
  'marketplace.confirmation.shipping_date';
export const MP_ORDER_CONFIRMATION_SHIPPING_DELIVERING_TO =
  'marketplace.confirmation.shipping_delivering_to';
export const MP_ORDER_CONFIRMATION_SHIPPING_DELIVERY_WINDOW =
  'marketplace.confirmation.shipping_delivery_window';
export const MP_ORDER_CONFIRMATION_VIEW = 'marketplace.confirmation.view';
export const MP_ORDER_CONFIRMATION_HIDE = 'marketplace.confirmation.hide';
export const MARKETPLACE_TAX = 'marketplace.tax';
export const MARKETPLACE_TRACKING_CONFIRMED_TITLE =
  'marketplace.tracking.confirmed.title';
export const MARKETPLACE_TRACKING_CONFIRMED_BODY =
  'marketplace.tracking.confirmed.body';
export const MARKETPLACE_TRACKING_SHIPPED_TITLE =
  'marketplace.tracking.shipped.title';
export const MARKETPLACE_TRACKING_SHIPPED_BODY =
  'marketplace.tracking.shipped.body';
export const MARKETPLACE_TRACKING_ARRIVED_TITLE =
  'marketplace.tracking.arrived.title';
export const MARKETPLACE_TRACKING_ARRIVED_BODY =
  'marketplace.tracking.arrived.body';
export const MARKETPLACE_TRACKING_ORDER_NUMBER =
  'marketplace.tracking.order_number';
export const MARKETPLACE_TRACKING_STATUS = 'marketplace.tracking_status';
export const MARKETPLACE_TRACKING_CANCELLED_TITLE =
  'marketplace.tracking.cancelled.title';
export const SUGGESTED_PRODUCTS_TITLE = 'cart.title';
export const SUGGESTED_PRODUCTS_CONTINUE_SHOPPING = 'cart.continue_shopping';
export const SUGGESTED_PRODUCTS_START_SHOPPING = 'cart.start_shopping';
export const VIEW_ALL = 'cart.view_all';
export const SUGGESTED_PRODUCTS = 'cart.suggested_products';
export const SUGGESTED_PRODUCTS_EMPTY = 'cart.suggested_products_empty';
export const SUGGESTED_PRODUCTS_REWARDS = 'cart.suggested_products_rewards';
export const SHOP_NOW = 'cart.shop_now';
export const VIEW_ALL_PRODUCTS = 'cart.view_all_products';
export const NEED_HELP = 'cart.need_help';
export const CHANGE_SELECTION = 'cart.change_selection';
export const PRICE_EA = 'cart.price_ea';
export const SHOP_POPULAR_GIFTS = 'Shop Popular Gifts';
export const WANT_TO_SHOP_LABEL = 'want to start shopping?';
export const SAVEBTN = 'cart.button.save';
export const ORDER_CONTACTS_ADD_BUTTON =
  'orderContacts.order_contacts_add_button';
export const MARKETPLACE_NO_NOTIFICATIONS = 'marketplace.card_no_notifications';
export const MARKETPLACE_NO_NOTIFICATIONS_TITLE = 'card_no_notifications_title';
export const MP_CARD_LINK_COPY = 'marketplace.digital_card.link.copy';
export const MP_CARD_LINK_COPIED = 'marketplace.digital_card.link.copied';
export const MP_CARD_LINK_LABEL = 'marketplace.digital_card.link.label';
export const TAX1_NAME = 'tax1.name';
export const TAX2_NAME = 'tax2.name';
export const TAX3_NAME = 'tax3.name';
export const TAX4_NAME = 'tax4.name';
export const TAX5_NAME = 'tax5.name';
export const ENTER_VALID_EMAIL =
  'marketplace.delivery_method.enter_valid_email';
export const MP_CHANGE_RECIPIENT = 'marketplace.change_recipient';
export const MP_DELIVERED_TO = 'marketplace.delivered_to';
export const MP_SHIPPING = 'marketplace.shipping';
export const GIFTING_EXPERIENCE_TITLE = 'gifting_experience.title';
export const GIFTING_EXPERIENCE_SUBTITLE = 'gifting_experience.subtitle';
export const GIFTING_EXPERIENCE_DESCRIPTION = 'gifting_experience.description';
export const PDP_HIGHLIGHT_REVIEWS_TITLE = 'pdp.highlight_reviews_title';
export const PDP_MOTHER_DAY_BANNER_TITLE = 'pdp.mother_day_banner_title';
export const PDP_MOTHER_DAY_BANNER_DESCRIPTION =
  'pdp.mother_day_banner_description';
export const PDP_MOTHER_DAY_BANNER_DESCRIPTION_LINK =
  'gifting_experience.learn_more_link';
export const GIFTING_EXPERIENCE_INLINE_SUBTITLE =
  'gifting_experience.inline_subtitle';
export const GIFTING_EXPERIENCE_LEARN_MORE = 'gifting_experience.learn_more';
export const CHOOSE_YOUR_STYLE = 'pdp.choose_your_style';
export const CHOOSE_YOUR_WRAP = 'pdp.choose_your_wrap';
export const LEARN_MORE_PACKING = 'pdp.learn_more_packaging';
export const BANNER_ALT_TEXT = 'banners.alt_text';
export const DELIVERY_FEE_DISCLAIMER_CA = 'delivery.disclaimer_ca';
export const DELIVERY_FEE_DISCLAIMER_US = 'delivery.disclaimer_us';

export const ORDER_CONFIRMATION_TIPPING_NONE =
  'order_confirmation_tipping_none';
export const GET_IN_THE_KNOW_EMAIL_LABEL =
  'marketing_goody_landing.get_in_the_know.email_label';
export const GET_IN_THE_KNOW_PHONE_LABEL =
  'marketing_goody_landing.get_in_the_know.phone_label';
export const GET_IN_THE_KNOW_DISCLAIMER =
  'marketing_goody_landing.get_in_the_know.disclaimer';
export const GET_IN_THE_KNOW_AGREE_TERMS =
  'marketing_goody_landing.get_in_the_know.agree_terms';
export const GET_IN_THE_KNOW_TERMS_AND_CONDITIONS =
  'marketing_goody_landing.get_in_the_know.terms_and_conditions';
export const GET_IN_THE_KNOW_TERMS_OF_USE =
  'marketing_goody_landing.get_in_the_know.terms_of_use';
export const GET_IN_THE_KNOW_COMMUNICATIONS_POLICY =
  'marketing_goody_landing.get_in_the_know.communications_policy';
export const GET_IN_THE_KNOW_SUBMIT_BUTTON =
  'marketing_goody_landing.get_in_the_know.submit_button';
export const GET_IN_THE_KNOW_SUBMITTING_BUTTON =
  'marketing_goody_landing.get_in_the_know.submitting_button';
export const GET_IN_THE_KNOW_SUCCESS_TITLE =
  'marketing_goody_landing.get_in_the_know.success_title';
export const GET_IN_THE_KNOW_SUCCESS_MESSAGE =
  'marketing_goody_landing.get_in_the_know.success_message';
export const GET_IN_THE_KNOW_EMAIL_ERROR =
  'marketing_goody_landing.get_in_the_know.email_error';
export const GET_IN_THE_KNOW_PHONE_ERROR =
  'marketing_goody_landing.get_in_the_know.phone_error';
export const SIGN_UP_GRID_GET_IN_THE_KNOW_TITLE =
  'marketing_goody_landing.sign_up_grid.get_in_the_know_title';
export const SIGN_UP_GRID_GET_IN_THE_KNOW_DESCRIPTION =
  'marketing_goody_landing.sign_up_grid.get_in_the_know_description';

export const GOODY_MARKETING_LANDING_HERO_BANNER_TITLE =
  'goody_marketing_landing_hero_banner_title';
export const GOODY_MARKETING_LANDING_HERO_BANNER_SUBTITLE =
  'goody_marketing_landing_hero_banner_subtitle';
export const GOODY_MARKETING_LANDING_HERO_BANNER_ITEM_1 =
  'goody_marketing_landing_hero_banner_item_1';
export const GOODY_MARKETING_LANDING_HERO_BANNER_ITEM_2 =
  'goody_marketing_landing_hero_banner_item_2';
export const GOODY_MARKETING_LANDING_HERO_BANNER_ITEM_3 =
  'goody_marketing_landing_hero_banner_item_3';
export const GOODY_MARKETING_LANDING_NEED_A_GIFT_NOW =
  'goody_marketing_landing_need_a_gift_now';
export const GOODY_MARKETING_LANDING_NEED_A_GIFT_NOW_DESCRIPTION =
  'goody_marketing_landing_need_a_gift_now_description';
export const GOODY_MARKETING_LANDING_SHOP_NOW =
  'goody_marketing_landing_shop_now';
export const GOODY_MARKETING_LANDING_NOW_DELIVERING =
  'goody_marketing_landing_now_delivering';
export const GOODY_MARKETING_LANDING_NOW_DELIVERING_DESCRIPTION =
  'goody_marketing_landing_now_delivering_description';

export const GOODY_MARKETING_LANDING_NOW_DELIVERING_FIRST_ITEM =
  'goody_marketing_landing_now_delivering_first_item';
export const GOODY_MARKETING_LANDING_NOW_DELIVERING_SECOND_ITEM =
  'goody_marketing_landing_now_delivering_second_item';

export const GOODY_MARKETING_LANDING_PRODUCT_GRID_TITLE =
  'goody_marketing_landing_product_grid_title';
export const GOODY_MARKETING_LANDING_PRODUCT_GRID_DESCRIPTION =
  'goody_marketing_landing_product_grid_description';

export const GOODY_MARKETING_LANDING_MARKETPLACE_FAQS =
  'goody_marketing_landing_marketplace_faqs';

export const SUBSCRIPTION_SUCCESS_POPUP_GOODY_POPUP_GIFT_TEXT =
  'subscription_success_popup_goody_popup_gift_text';

export const SUBSCRIPTION_SUCCESS_POPUP_GOODY_BUTTON_TEXT =
  'subscription_success_popup_goody_button_text';

export const SUBSCRIPTION_SUCCESS_POPUP_GOODY_DESCRIPTION_LAST =
  'subscription_success_popup_goody_description_last';

export const WHO_WE_ARE_TITLE = 'who_we_are.title';
export const WHO_WE_ARE_SUBTITLE = 'who_we_are.subtitle';
export const WHO_WE_ARE_FEATURED_ITEM_1_TITLE =
  'who_we_are.featured_item_1.title';
export const WHO_WE_ARE_FEATURED_ITEM_1_DESCRIPTION =
  'who_we_are.featured_item_1.description';
export const WHO_WE_ARE_FEATURED_ITEM_2_TITLE =
  'who_we_are.featured_item_2.title';
export const WHO_WE_ARE_FEATURED_ITEM_2_DESCRIPTION =
  'who_we_are.featured_item_2.description';
export const WHO_WE_ARE_FEATURED_ITEM_3_TITLE =
  'who_we_are.featured_item_3.title';
export const WHO_WE_ARE_FEATURED_ITEM_3_DESCRIPTION =
  'who_we_are.featured_item_3.description';
export const WHO_WE_ARE_FEATURED_ITEM_4_TITLE =
  'who_we_are.featured_item_4.title';
export const WHO_WE_ARE_FEATURED_ITEM_4_DESCRIPTION =
  'who_we_are.featured_item_4.description';
export const WHO_WE_ARE_FEATURED_ITEM_5_TITLE =
  'who_we_are.featured_item_5.title';
export const WHO_WE_ARE_FEATURED_ITEM_5_DESCRIPTION =
  'who_we_are.featured_item_5.description';

export const WHO_WE_ARE_OUR_MISSION_TITLE = 'who_we_are.our_mission.title';
export const WHO_WE_ARE_OUR_MISSION_SUBTITLE =
  'who_we_are.our_mission.subtitle';
export const WHO_WE_ARE_OUR_MISSION_DESCRIPTION =
  'who_we_are.our_mission.description';
export const WHO_WE_ARE_OUR_MISSION_BUTTON_TEXT =
  'who_we_are.our_mission.button_text';

export const WHO_WE_ARE_HISTORY_TITLE = 'who_we_are.history.title';
export const WHO_WE_ARE_HISTORY_BEGINNING_TITLE =
  'who_we_are.history.beginning.title';
export const WHO_WE_ARE_HISTORY_BEGINNING_DESCRIPTION =
  'who_we_are.history.beginning.description';
export const WHO_WE_ARE_HISTORY_FUTURE_TITLE =
  'who_we_are.history.future.title';
export const WHO_WE_ARE_HISTORY_FUTURE_DESCRIPTION =
  'who_we_are.history.future.description';
export const WHO_WE_ARE_HISTORY_BUTTON_TEXT = 'who_we_are.history.button_text';

export const WHO_WE_ARE_TREATS_TITLE = 'who_we_are.treats.title';

export const WHO_WE_ARE_LEADERSHIP_TITLE = 'who_we_are.leadership.title';

export const WHO_WE_ARE_LEADERSHIP_FOUNDER_TITLE =
  'who_we_are.leadership.founder.title';
export const WHO_WE_ARE_LEADERSHIP_FOUNDER_DESCRIPTION_ONE =
  'who_we_are.leadership.founder.description_one';
export const WHO_WE_ARE_LEADERSHIP_FOUNDER_DESCRIPTION_TWO =
  'who_we_are.leadership.founder.description_two';
export const WHO_WE_ARE_LEADERSHIP_FOUNDER_DESCRIPTION_THREE =
  'who_we_are.leadership.founder.description_three';
export const WHO_WE_ARE_LEADERSHIP_FOUNDER_DESCRIPTION_FOUR =
  'who_we_are.leadership.founder.description_four';

export const WHO_WE_ARE_LEADERSHIP_CEO_TITLE =
  'who_we_are.leadership.ceo.title';
export const WHO_WE_ARE_LEADERSHIP_CEO_DESCRIPTION_ONE =
  'who_we_are.leadership.ceo.description_one';
export const WHO_WE_ARE_LEADERSHIP_CEO_DESCRIPTION_TWO =
  'who_we_are.leadership.ceo.description_two';
export const WHO_WE_ARE_LEADERSHIP_CEO_DESCRIPTION_THREE =
  'who_we_are.leadership.ceo.description_three';
export const WHO_WE_ARE_LEADERSHIP_CEO_DESCRIPTION_FOUR =
  'who_we_are.leadership.ceo.description_four';
export const WHO_WE_ARE_LEADERSHIP_VIEW_MORE =
  'who_we_are.leadership.ceo.view_more';
export const WHO_WE_ARE_LEADERSHIP_VIEW_LESS =
  'who_we_are.leadership.ceo.view_less';

export const WHO_WE_ARE_GUARANTEE_TITLE = 'who_we_are.guarantee.title';
export const WHO_WE_ARE_GUARANTEE_DESCRIPTION =
  'who_we_are.guarantee.description';
export const WHO_WE_ARE_GUARANTEE_BUTTON_TEXT =
  'who_we_are.guarantee.button_text';

export const WHO_WE_ARE_QUOTE_TEXT = 'who_we_are.quote.text';

export const WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_TITLE =
  'who_we_are.awards_and_achievements.title';
export const WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_DESCRIPTION =
  'who_we_are.awards_and_achievements.description';
export const WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_BUTTON_TEXT =
  'who_we_are.awards_and_achievements.button_text';

export const WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_AWARD_1_TITLE =
  'who_we_are.awards_and_achievements.award_1.title';
export const WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_AWARD_1_DESCRIPTION =
  'who_we_are.awards_and_achievements.award_1.description';
export const WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_AWARD_2_TITLE =
  'who_we_are.awards_and_achievements.award_2.title';
export const WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_AWARD_2_DESCRIPTION =
  'who_we_are.awards_and_achievements.award_2.description';
export const WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_AWARD_3_TITLE =
  'who_we_are.awards_and_achievements.award_3.title';
export const WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_AWARD_3_DESCRIPTION =
  'who_we_are.awards_and_achievements.award_3.description';
export const WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_AWARD_4_TITLE =
  'who_we_are.awards_and_achievements.award_4.title';
export const WHO_WE_ARE_AWARDS_AND_ACHIEVEMENTS_AWARD_4_DESCRIPTION =
  'who_we_are.awards_and_achievements.award_4.description';
export const WHO_WE_ARE_CAREERS_TITLE = 'who_we_are.careers.title';
export const WHO_WE_ARE_CAREERS_DESCRIPTION = 'who_we_are.careers.description';
export const WHO_WE_ARE_CAREERS_BUTTON_TEXT_ONE =
  'who_we_are.careers.button_text_one';
export const WHO_WE_ARE_CAREERS_BUTTON_TEXT_TWO =
  'who_we_are.careers.button_text_two';

export const WHO_WE_ARE_PRODUCT_CAROUSEL_TITLE =
  'who_we_are.product_carousel.title';
export const WHO_WE_ARE_PRODUCT_CAROUSEL_BUTTON_TEXT =
  'who_we_are.product_carousel.button_text';

// Catering EventDetails translations
export const CATERING_EVENT_DETAILS_TITLE = 'catering.event_details.title';
export const CATERING_EVENT_DETAILS_NO_DETAILS_MESSAGE =
  'catering.event_details.no_details_message';
export const CATERING_ORDER_TYPE_LABEL = 'catering.order_type.label';
export const CATERING_ZIP_CODE_LABEL = 'catering.zip_code.label';
export const CATERING_EVENT_DATE_LABEL = 'catering.event_date.label';
export const CATERING_PICKUP_STORE_LABEL = 'catering.pickup_store.label';
export const CATERING_DELIVERY_STORE_LABEL = 'catering.delivery_store.label';
export const CATERING_DELIVERY = 'catering.delivery';
export const CATERING_PICKUP = 'catering.pickup';
export const CATERING_SHOW_MORE_PRODUCTS = 'catering.show_more_button';
export const CATERING_ADD_DETAILS = 'catering.add_details';
export const CATERING_EDIT_DETAILS = 'catering.edit_details';
export const CATERING_SHOWING_RESULTS = 'catering.showing_results';
export const CATERING_SELECT_PICKUP_STORE = 'catering.select_pickup_store';
export const CATERING_SELECT_DELIVERY_STORE = 'catering.select_delivery_store';
export const CATERING_LOADING_STORES = 'catering.loading_stores';
export const CATERING_NO_STORES_FOUND = 'catering.no_stores_found';
export const CATERING_SELECT_STORE = 'catering.select_store';
export const CATERING_LOAD_MORE_STORES = 'catering.load_more_stores';
export const CATERING_EVENT_DETAILS_MODAL_TITLE =
  'catering.event_details_modal.title';
export const CATERING_TELL_US_ABOUT_EVENT = 'catering.tell_us_about_event';
export const CATERING_WHERE_IS_EVENT = 'catering.where_is_event';
export const CATERING_EVENT_DATE_REQUIRED = 'catering.event_date_required';
export const CATERING_SELECT_DATE = 'catering.select_date';
export const CATERING_SELECT_ORDER_TYPE = 'catering.select_order_type';
export const CATERING_UNAVAILABLE = 'catering.unavailable';
export const CATERING_SELECT_A_STORE = 'catering.select_a_store';
export const CATERING_START_ORDER = 'catering.start_order';
export const CATERING_UPDATE_ORDER = 'catering.update-order';
export const CATERING_ZIP_CODE_REQUIRED = 'catering.zip_code_required';
export const CATERING_ORDER_TYPE_REQUIRED = 'catering.order_type_required';
export const CATERING_ENTER_ZIP_CODE = 'catering.enter_zip_code';
export const CATERING_ENTER_POSTAL_CODE = 'catering.enter_postal_code';
export const CATERING_VALID_ZIP_CODE = 'catering.valid_zip_code';
export const CATERING_VALID_POSTAL_CODE = 'catering.valid_postal_code';
export const CATERING_VALID_CANADIAN_POSTAL_CODE =
  'catering.valid_canadian_postal_code';
export const CATERING_ZIP_NOT_SERVICED = 'catering.zip_not_serviced';
export const CATERING_ERROR_GETTING_COORDINATES =
  'catering.error_getting_coordinates';
export const CATERING_ERROR_LOADING_STORES = 'catering.error_loading_stores';
export const CATERING_NO_STORES_ZIP_CODE = 'catering.no_stores_zip_code';
export const CATERING_NO_STORES_AVAILABLE_DATE =
  'catering.no_stores_available_date';
export const CATERING_CURBSIDE = 'catering.curbside';
export const CATERING_SMOOTHIE = 'catering.smoothie';
export const CATERING_DELIVERY_SERVICE = 'catering.delivery_service';
export const CATERING_ADD_TO_CART_BUTTON = 'catering.add_to_cart';

// Catering MiniCart translations
export const CATERING_MINICART_SUBTOTAL = 'catering.minicart.subtotal';
export const CATERING_MINICART_SALES_TAX = 'catering.minicart.sales_tax';
export const CATERING_MINICART_DELIVERY_FEES =
  'catering.minicart.delivery_fees';
export const CATERING_MINICART_DELIVERY_FEES_INFO =
  'catering.minicart.delivery_fees_info';
export const CATERING_MINICART_REVIEW_CHECKOUT =
  'catering.minicart.review_checkout';
export const CATERING_MINIMUM_ORDER_WARNING =
  'catering.minicart.minimum_order_warning';
export const CATERING_MINICART_FREE = 'catering.minicart.free';
export const CATERING_MINICART_DELIVERY_UNLOCKED =
  'catering.minicart.delivery_unlocked';
export const CATERING_DISCLAIMER = 'catering.disclaimer';
export const CATERING_UTENSILS_DISCLAIMER = 'catering.utensils_disclaimer';
export const CATERING_TEXT = 'catering.text';
export const CATERING_MENU = 'catering.menu';
export const CATERING_BACK = 'catering.back';
export const CATERING_COLLECTION = 'catering.collection';
export const CATERING_COLLECTION_SUBTEXT = 'catering.collection.subtext';
export const CATERING_VIEW_MORE = 'catering.view.more';
export const CATERING_VIEW_LESS = 'catering.view.less';
export const CATERING_CONTACT_DETAILS = 'catering.contact.details';
export const CATERING_SHOW_TEXT = 'catering.show.text';
export const CATERING_OF_TEXT = 'catering.of.text';
export const CATERING_RESULTS_TEXT = 'catering.results.text';
export const CATERING_SORT_TEXT = 'catering.sort.text';
export const CATERING_ERROR_404_OOPS = 'catering.error.404.oops';
export const CATERING_ERROR_404_TEXT = 'catering.error.404.text';
export const CATERING_ERROR_404_UPDATE = 'catering.error.404.update';
export const CATERING_ERROR_404_CLEAR = 'catering.error.404.clear';
export const CATERING_FAQ_TEXT = 'catering.faq.text';
export const CATERING_CAROUSEL_TITLE = 'catering.carousel.title';
export const CATERING_DELIVERY_HEADING = 'catering.delivery.heading';
export const CATERING_PICKUP_HEADING = 'catering.pickup.heading';
export const CATERING_PICKUP_FROM = 'catering.pickup.from';
export const ZIP_USA_ERROR = 'pdp.availability.zip_usa_error';
export const ZIP_USA_ERROR_SUB = 'pdp.availability.zip_usa_error_sub';
export const SHOP_EDIBLE_US = 'pdp.availability.shop_edible_us';
export const STORE_FINDER_SEARCH_LABEL = 'store_finder_page.searchlabel_text';
export const CATERING_HEADER_DELIVERY = 'catering.order.header.delivery';
export const CATERING_CONTACTS_EMAIL_LABEL = 'catering.contacts.email.label';
export const CATERING_DELIVERY_DETAILS = 'catering.delivery_details';
export const DELIVERY_FROM_STORE = 'catering.delivery_from_store';
export const CATERING_DELIVERY_DATE = 'catering.delivery_date';
export const CATERING_DELIVERY_TIME = 'catering.delivery_time';
export const CATERING_DELIVERY_CHOICE = 'catering.delivery_choice';
export const CATERING_DELIVERY_FREE = 'catering.delivery_free';
export const CATERING_DELIVERY_UNLOCKED = 'catering.delivery_unlocked';
export const CATERING_EVENT_ADDRESS = 'catering.event_address';
export const DELIVERY_TIME_SELECT = 'pdp.delivery_time_select';
export const CATERING_SIZE_TEXT = 'catering.size_text';
export const SELECT_SIZE_TEXT = 'pdp.select_size_text';
export const REFRESH_TITLE = 'catering.refresh_title';
export const REFRESH_MESSAGE_WITH_CART = 'catering.refresh_message_with_cart';
export const REFRESH_MESSAGE_WITHOUT_CART =
  'catering.refresh_message_without_cart';
export const REFRESH_YES = 'catering.refresh_yes';
export const REFRESH_CANCEL = 'catering.refresh_cancel';
